export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XII - Issue 120",
    "shortTitle": "",
    "description": "",
    "width": 1173,
    "height": 880,
    "currentLanguage": "ES",
    "languages": [{
      code: "EN",
      text: "English",
      href: "https://escrime-xxi.fie.org/120/en/"
    },
    {
      code: "FR",
      text: "French",
      href: "https://escrime-xxi.fie.org/120/fr/"
    },
    {
      code: "ES",
      text: "Spanish",
      href: "https://escrime-xxi.fie.org/120/es/"
    }],
    "basePath": "/120/es",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://escrime-xxi.fie.org/120/es/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '/120/es/static/_content/escrime-120-es.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": true,
      "guideEnabled": false,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 1-title" style="top:84px;left:52px;" src="/120/es/static/_content/1-title-1.png">
        <img class="abs halfScale 1-title" style="top:210px;left:52px;" src="/120/es/static/_content/1-title-2.png">
        <img class="abs halfScale 1-title" style="top:1px;left:290px;" src="/120/es/static/_content/1-numerals-1.png">
        <img class="abs halfScale 1-title" style="top:84px;left:824px;" src="/120/es/static/_content/1-ed-1.png">
        <!-- <img class="abs halfScale 1-title" style="top:84px;left:957px;" src="/120/es/static/_content/logo.png"> -->
        <img class="abs halfScale 1-title" style="top:360px;left:50px;" src="/120/es/static/_content/1-sub-1.png">
        <img class="abs halfScale 1-title" style="top:503px;left:53px;" src="/120/es/static/_content/1-sub-2.png">
        <img class="abs halfScale 1-title" style="top:569px;left:54px;" src="/120/es/static/_content/1-sub-3.png">
        <img id="1-arrow" class="halfScale pointer" style="top:756px;right:-70px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/1-arrow.png">
      `,
      "mobileHtml": `
        <img src="/120/es/static/_content/1-mobile-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
            .staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(idOf("1-arrow"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
      
        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "N˚120 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  Campeonatos del Mundo Juniors y Cadetes Copa del Mundo Gran Premio  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 2-title" style="top:84px;left:64px;" src="/120/es/static/_content/2-title-1.png">
        <img class="abs halfScale pointer howto-desktop" style="top:96px;left:822px;" onclick="switchPopHowto(true)"
          src="/120/es/static/_content/2-btn-1.png">
        <img class="abs halfScale pointer howto-ipad" style="top:96px;left:976px;opacity:0" onclick="switchPopHowto(false)"
          src="/120/es/static/_content/2-ipad-btn.png">
        <img class="abs halfScale 2-img howto-desktop" style="top:202px;left:64px;" src="/120/es/static/_content/2-img-1.png">
        <img class="abs halfScale 2-img howto-ipad" style="top:191px;left:64px; opacity:0" src="/120/es/static/_content/2-ipad.png">
        <img class="abs halfScaleC 2-text" style="top:605px;left:20px;" src="/120/es/static/_content/2-text-1.png">
        <img class="abs halfScaleC 2-text" style="top:599px;left:236px;" src="/120/es/static/_content/2-text-2.png">
        <img class="abs halfScaleC 2-text" style="top:597px;left:538px;" src="/120/es/static/_content/2-text-3.png">
        <img class="abs halfScaleC 2-text" style="top:597px;left:799px;" src="/120/es/static/_content/2-text-4.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim
            .staggerFromTo(cOf("2-text"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop();
          resetNumbers("2-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  DEP ORTE  GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA EN BUDAPEST BUDAPEST, HUNGRÍA 4–6 MARZO 2022  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  Navegación  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.absolutefencinggear.com/" target="_blank" class="contentLinkNone" style="    top: 720px; left: 430px; width: 710px; height: 60px;"></a>
      `,
      "mobileHtml": `
        <a href="https://www.absolutefencinggear.com/" target="_blank">
          <img src="/120/es/static/_content/3-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 4-title" style="top:47px;left:63px;" src="/120/es/static/_content/4-title-1.png">
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 47px; left:644px;" src="/120/es/static/_content/fb-navy.png">
        </a>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC abs halfpulse animatedpulse" style="top: 86px; left:644px;" src="/120/es/static/_content/tw-navy.png">
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        <img id="4-next" class="halfScale pointer" style="top:719px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-sky.png">

          <img class="cont-item cont-item-1-btn" style="top:251px;left:439px;opacity:0;transform:scale(0.9); transform-origin:top left;"
              src="/120/es/static/_content/4-popup-1-1.png">
          <img class="cont-item cont-item-2-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-2-1.png">
          <img class="cont-item cont-item-3-btn halfScale" style="top:259px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-2-2.png">
          <img class="cont-item cont-item-4-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-3-1.png">
          <img class="cont-item cont-item-5-btn halfScale" style="top:269px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-4-1.png">
          <img class="cont-item cont-item-6-btn halfScale" style="top:204px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-5-1.png">
          <img class="cont-item cont-item-7-btn halfScale" style="top:251px;left:440px;opacity:0"
            src="/120/es/static/_content/4-popup-6-1.png">
          
          <div class="addContentLink" onclick="contentsBub(1);" style="top: 275px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(2);" style="top: 345px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(2);"
          style="top: 715px; left: 496px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 2-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="contentLinkNone 3-click" onclick="contentsBub(3);"
            style="top: 715px; left: 688px; width: 169px; height: 54px;display:none"></div>
          <div class="addContentLink" onclick="contentsBub(4);" style="top: 415px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(5);" style="top: 486px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(6);" style="top: 556px; left: 65px; width: 377px; height: 50px;"></div>
          <div class="addContentLink" onclick="contentsBub(7);" style="top: 626px; left: 65px; width: 377px; height: 50px;"></div>
          
          <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)"
            style="top: 273px; left: 442px; width: 594px; height: 50px;display:none;"></div>

          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(10)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(14)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(17)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(20)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(22)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(25)"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(27)"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(31)"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(33)"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(35)"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(39)"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(45)"
            style="top: 415px; left: 442px; width: 590px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-5-link"
            onclick="Publish.goToPage(47)"
            style="top: 486px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})"
            style="top: 556px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})"
            style="top: 626px; left: 442px; width: 636px; height: 50px;display:none;"></div>
          
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})"
            style="top: 275px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})"
            style="top: 345px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})"
            style="top: 415px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})"
            style="top: 486px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})"
            style="top: 556px; left: 442px; width: 594px; height: 50px;display:none;"></div>
          <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})"
            style="top: 626px; left: 442px; width: 594px; height: 50px;display:none;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim
            .fromTo(cOf("4-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function contentsBub(index){
          console.log(index)
          for(var i=0; i <= 9; i++){
            if(i == index){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "";
              },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                c.style.display = "";
              },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:1, onComplete:function(){
                
                cOf("cont-item-"+index+"-link")[0].style.display = ""
                if(cOf("cont-item-"+index+"-link")[1]){
                  cOf("cont-item-"+index+"-link")[1].style.display = "" 
                }
              }});
            }else{
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              [].slice.call(cOf(i+"-click")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0, {opacity:0});
            }
          }
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("4-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ÍNDICE  EN ESTE NÚMERO  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada.  WWW.FIE.ORG  EDITORIAL  DEPORTE  Pulse los botones para revelar el contenido  NOTICIAS DE LA FIE N˚120  NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN  REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  NOTICIAS DEL MUNDO  Campeonatos del Mundo Juniors y Cadetes Copa del Mundo  NECROLÓGICAS  Gran Premio  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:info@fie.ch">
          <div class="contentLink" style="bottom: 162px; right: 526px; width: 124px; height: 21px;"></div>
        </a>
        <a href="http://www.touchline.com" target="_blank">
          <div class="contentLink" style="bottom: 160px; right: 236px; width: 234px; height: 21px;"></div>
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLink" style="bottom: 140px; right: 568px; width: 82px; height: 21px;"></div>
        </a>

        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:41px"
            src="/120/es/static/_content/tw-white.png">
        </a>

        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:94px"
            src="/120/es/static/_content/fb-white.png">
        </a>

        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:785px;left:147px"
            src="/120/es/static/_content/yt-white.png">
        </a>

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <img id="5-next" class="halfScale pointer" style="top:653px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-sky.png">
      `,
      "mobileHtml": `
        <p><strong>Presidente interino:</strong><br>Emmanuel Katsiadakis (M.H.) (GRE)
          <br><strong>Secretaria tesorera:</strong><br>Ferial Nadira Salhi (ALG)
        </p>
        <p><strong>Vicepresidentes:</strong><br>Ana Pascu (M.H.) (ROU)<br>Donald Anthony (USA)<br>Yuki Ota (JPN)</p>
        <p><strong>Miembros:</strong><br>Erika Aze (LAT)<br>Jacek Bierkowski (POL)<br>Ana Irene Delgado Guerra (PAN)<br>Velichka Hristeva (BUL)<br>Isabelle Lamour (FRA)<br>Novak Perovic (RSA)<br>Oleg Peskov (KAZ)<br>Giorgio Scarso (ITA)<br>Bence Szabo (HUN)<br>Pascal Tesch (LUX)<br>Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)</p>
        <p><strong>Presidente de la Confederación Africana de Esgrima:</strong><br>Mbagnick Ndiaye (SEN) <br><strong>Presidente de la Confederación Panamericana de Esgrima:</strong><br>Vitaly Logvin (MEX) <br><strong>Presidente de la Confederación Asiática de Esgrima:</strong><br>HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE)<br><strong>Presidente de la Confederación Europea de Esgrima:</strong><br>Stanislav Pozdnyakov (RUS)
          <br><strong>Presidente de la Confederación Oceánica de Esgrima:</strong><br>Helen Smith (M.H.) (AUS)
        </p>
        <h2 id="fie-head-office">OFICINA CENTRAL DE LA FIE</h2>
        <p><strong>Directora general</strong><br>Nathalie Rodriguez M.-H. (FRA)
        </p>
        <h2 id="administration">Administración</h2>
        <p><strong>Directora administrativa:</strong><br>Elena Murdaca (ITA)<br><strong>Gestora de contabilidad:</strong><br>Sandra Baroni (SUI) <br><strong>Asistente de dirección:</strong><br>Gabrielle Meylan (BRA)<br><strong>Asistente administrativa:</strong><br>Ylenia Murdaca (ITA)</p>
        <h2 id="sport">Deporte</h2>
        <p><strong>Director técnico y deportivo:</strong><br>Evgeny Tsoukhlo (RUS)<br><strong>Manager de la tecnología y de la administración del deporte:</strong><br>Natalia Bodrova (RUS)<br><strong>Jefe de operaciones:</strong><br>Elena Huot (RUS)</p>
        <h2 id="communication-marketing-tv">Comunicación, Marketing, TV</h2>
        <p><strong>Jefe del gabinete del presidente:</strong><br>Nina Lalovic (SRB)<br><strong>Manager digital y de comunicaciones:</strong><br>Maria Ntanou (GRE)<br><strong>Jefe de producción TV de la FIE:</strong><br>Barna Heder (HUN) <br><strong>Asistente de producción TV de la FIE:</strong><br>Svetlana Krasnokoutskaya (RUS)<br><strong>Encargado de prensa:</strong><br>Serge Timacheff (USA)<br><strong>Fotógrafo:</strong><br>Augusto Bizzi (ITA)</p>
        <h2 id="design">Diseño</h2>
        <p>Touchline (www.touchline.com)</p>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim
            .fromTo(idOf("5-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("5-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "C OMITÉ E JECUTIVO DE L A FIE  OFICINA CENTRAL DE LA FIE  Presidente interino: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  Directora general Nathalie Rodriguez M.-H. (FRA)  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros:  Administración  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA)  Erika Aze (LAT) Jacek Bierkowski (POL) Ana Irene Delgado Guerra (PAN) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX)  Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Jefe de operaciones: Elena Huot (RUS) Comunicación, Marketing, TV  Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Jefe del gabinete del presidente:  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Nina Lalovic (SRB)  Manager digital y de comunicaciones: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Diseño Touchline (www.touchline.com)  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img id="6-img" class="halfScale 6-text-1 6-text" style="top:145px;left:367px"
          src="/120/es/static/_content/6-img-1.png">
        <img id="6-title" class="halfScale 6-title 6-text-1 6-text" style="top:629px;left:329px"
          src="/120/es/static/_content/6-title-1.png">
        
        <img id="6-text-1" class="halfScale 6-text-1 6-text" style="top:143px;left:601px"
          src="/120/es/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:143px;left:155px; opacity:0;"
          src="/120/es/static/_content/6-text-2.png">
        
        <img id="6-cta-1" class="halfScale pointer 6-btn" style="top: 697px; left: 599px;transform: scale(0.505);"
          onclick="toggleText6(false);" src="/120/es/static/_content/6-btn-1.png">
        <img id="6-cta-2" class="halfScale pointer 6-btn" style="top: 697px; left: 813px;transform: scale(0.505);opacity:0"
          onclick="toggleText6(true);" src="/120/es/static/_content/6-btn-2.png">

        <img id="6-next" class="halfScale pointer" style="top:719px;right:-80px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-navy.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <h2 id="together-we-are-fencing">Juntos estamos esgrima</h2>
        <img src="/120/es/static/_content/6-mobile-1.jpg">
        <p>  <strong>Estimados Amigos:</strong></p>
        <p>  Nos complace presentarles este número de Escrime, que abarca el mundo de la
          esgrima y su nueva fase de prosperidad a nivel mundial. En estos momentos de
          extrema dificultad, la FIE expresa su deseo de que, una vez más, la paz
          prevalezca en el mundo y, como familia mundial, nos unamos para ayudar a
          aquellos que más lo necesitan. El deporte representa una herramienta poderosa
          para generar la paz, la reconciliación y el entendimiento necesarios para
          conseguir un acercamiento entre personas. Podemos y deberíamos vivir en paz.
        </p>
        <p>  También hemos tenido que lidiar con una pandemia mundial durante los dos
          últimos años. Durante este periodo, la FIE y sus federaciones nacionales
          trabajaron para garantizar que nuestros eventos pudieran celebrarse de la
          manera más segura posible. Como resultado, las competiciones de la Copa del
          mundo y de los Grandes premios comenzaron a celebrarse con éxito y continuarán
          a lo largo del año, durante el cual se llevarán a cabo numerosas pruebas. Del
          mismo modo, acabamos de finalizar los Campeonatos del mundo de esgrima juniors
          y cadetes 2022 en Dubái, donde 1357 esgrimistas de 103 países, más que nunca
          en nuestra historia, se reunieron durante nueve días de competencia pacífica
          pero emocionante. </p>
        <p>  Próximamente, los Campeonatos del mundo de esgrima sénior darán la bienvenida
          a los Campeonatos del mundo veteranos en octubre. </p>
        <p>  Tras el clamoroso éxito de la esgrima en los Juegos Olímpicos de Tokio de
          2020, considero que nos encontramos en una posición más sólida que nunca para
          continuar desarrollando nuestra estrategia y para aumentar la popularidad de
          nuestro deporte, poniendo la vista en los próximos Juegos Olímpicos de París
          de 2024. El notable desarrollo de la esgrima ha quedado atestiguado en las
          redes sociales y en la televisión. Asimismo, la participación a nivel mundial
          muestra claramente que estamos en el camino correcto para seguir promoviendo
          nuestro deporte.</p>
        <p>  Este es el momento de volverse ingenioso e innovador con el fin de crear una
          esgrima a diferentes niveles para generar entusiasmo y aumentar la conciencia
          en todo el mundo. Hemos de continuar con el impulso de los últimos años para
          evolucionar con fuerza, entusiasmo y optimismo. </p>
        <p>  Os invito a todos a asumir vuestra función como embajadores de nuestro
          deporte, para que así nos volvamos más fuertes y destaquemos aún más dentro de
          nuestras comunidades y en las salas de esgrima. Ya seáis atletas,
          entrenadores, funcionarios, voluntarios o seguidores, todos vosotros
          desempeñáis un papel de enorme importancia como parte del éxito de la esgrima
          a nivel mundial; un papel que no puede ser infravalorado. </p><p>En nombre de la FIE, nos gustaría daros las gracias por vuestro continuo
          apoyo. Espero que disfrutéis de un saludable y próspero 2022. </p>
        <p>  Emmanuel Katsiadakis<br><strong>Presidente interino</strong></p>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim
            .fromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("6-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function toggleText6(bool){
          var text1 = idOf("6-text-1");
          var text2 = idOf("6-text-2");
          
          if(!bool && text1.style.opacity == "0"){
            pg6Anim.play();
            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
          }else if(bool && text2.style.opacity == "0"){
            pg6Anim.pause();
            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
          }
        }

        function onPageLeave() {
          pg6Anim.stop();
          resetNumbers("6-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "PRÓLO GO  Estimados Amigos: Nos complace presentarles este número de Escrime, que abarca el mundo de la esgrima y su nueva fase de prosperidad a nivel mundial. En estos momentos de extrema dificultad, la FIE expresa su deseo de que, una vez más, la paz prevalezca en el mundo y, como familia mundial, nos unamos para ayudar a aquellos que más lo necesitan. El deporte representa una herramienta poderosa para generar la paz, la reconciliación y el entendimiento necesarios para conseguir un acercamiento entre personas. Podemos y deberíamos vivir en paz.  JUNTOS ESTAMOS ESGRIMA  También hemos tenido que lidiar con una pandemia mundial durante los dos últimos años. Durante este periodo, la FIE y sus federaciones nacionales trabajaron para garantizar que nuestros eventos pudieran celebrarse de la manera más segura posible. Como resultado, las competiciones de la Copa del mundo y de los Grandes premios comenzaron a celebrarse con éxito y continuarán  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 723px; width: 193px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom:21px;right:505px;width:205px;height:38px;"></div>
        </a>
        <a href="https://www.instagram.com/pbt_fencing" target="_blank">
          <div class="contentLinkNone" style="bottom: 21px; right: 259px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://shop.pbtfencing.com/" target="_blank">
          <img src="/120/es/static/_content/7-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-title" style="top:127px;left:65px;" src="/120/es/static/_content/8-title-1.png">
        <img class="abs halfScale 8-sub" style="top:326px;left:97px;" src="/120/es/static/_content/8-sub-1.png">
        <img class="abs halfScale 8-line" style="top:328px;left:64px;" src="/120/es/static/_content/8-line-1.png">
        <img id="8-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament">El estadounidense Gassner y la italiana Cammilletti ganan el Torneo Satélite
          de Florete de Tashkent </h2>
        <img src="/120/es/static/_content/8-mobile-1.jpg">
        <p><strong>    Tashkent, Uzbekistán<br>29 de septiembre de 2021</strong></p>
        <p><strong>    El estadounidense Ethan Gassner y la italiana Marta Cammilletti ganaron las
            medallas de oro masculina y femenina en el Torneo Satélite Internacional de
            Florete de Tashkent, Uzbekistán, que se celebró los días 25 y 26 de
            septiembre.</strong></p>
        <p>  Participaron cuarenta y ocho atletas de diferentes países, incluidos
          Bielorrusia, Irán, Irak, Italia, Kazajstán, Filipinas, Turquía, EE. UU. y
          Uzbekistán. </p>
        <p>  En florete masculino individual, Gassner ganó frente al bielorruso Uladzislau
          Kurylovich por 15-10. Las medallas de bronce fueron para Akhmadillokhon
          Solikhojiev (UZB) y Mukhammad Yusuf Asranov (UZB). </p>
        <p>  En florete femenino individual, Cammilletti ganó frente a la filipina Maxine
          Isabel Esteban por 15-2. Las medallas de bronce fueron para Madinabonu
          Parpieva (UZB) y Umida Ilyosova (UZB). </p>
        <p>  El evento se celebró de conformidad con las normas de la FIE y el protocolo de
          COVID-19.</p>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("8-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("8-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("8-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  EL ESTADOUNIDENSE GASSNER Y LA ITALIANA CAMMILLETTI GANAN EL TORNEO SATÉLITE DE FLORETE DE TASHKENT TASHKENT, UZBEKISTÁN 29 DE SEPTIEMBRE DE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="9-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim
            .fromTo(idOf("9-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }

        function onPageLeave() {
          pg9Anim.stop();
          resetNumbers("9-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "TORNEO SATÉLITE DE FLORETE TASHKENT, UZBEKISTÁN 2/2  El estadounidense Ethan Gassner y la italiana Marta Cammilletti ganaron las medallas de oro masculina y femenina en el Torneo Satélite Internacional de Florete de Tashkent, Uzbekistán, que se celebró los días 25 y 26 de septiembre. Participaron cuarenta y ocho atletas de diferentes países, incluidos Bielorrusia, Irán, Irak, Italia, Kazajstán, Filipinas, Turquía, EE. UU. y Uzbekistán. En florete masculino individual, Gassner ganó frente al bielorruso Uladzislau Kurylovich por 15-10. Las medallas de bronce fueron para Akhmadillokhon Solikhojiev (UZB) y Mukhammad Yusuf Asranov (UZB). En florete femenino individual, Cammilletti ganó frente a la filipina Maxine Isabel Esteban por 15-2. Las medallas de bronce fueron para Madinabonu Parpieva (UZB) y Umida Ilyosova (UZB). El evento se celebró de conformidad con las normas de la FIE y el protocolo de COVID-19. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-title" style="top:99px;left:424px;" src="/120/es/static/_content/10-title-1.png">
        <img class="abs halfScale 10-sub" style="top:309px;left:456px;" src="/120/es/static/_content/10-sub-1.png">
        <img class="abs halfScale 10-line" style="top:308px;left:423px;" src="/120/es/static/_content/10-line-1.png">
        <img id="10-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix">El coreano Kim y la griega Georgiadou ganan el oro en el Gran Premio de Sable de Orleans de 2021</h2>
        <img src="/120/es/static/_content/10-mobile-1.jpg">
        <p><strong>Orleans, Francia<br>13 de noviembre de 2021</strong></p>
        <p><strong>En el primer Gran Premio de la FIE de la temporada de competencias 2021-2022, el campeón mundial coreano Junghwan Kim y la griega Despina Georgiadou ganaron las pruebas individuales masculina y femenina del Gran Premio de Sable de Orleans. </strong></p>
        <p>Las finales se celebraron en el recinto deportivo Zénith d'Orléans, y participaron en la competencia general 170 hombres y 162 mujeres.</p>
        <p>En la final de la prueba de sable masculino, Kim se enfrentó al italiano Luca Curatoli, ganando la medalla de oro por 15-3. Curatoli derrotó al japonés Kento Yoshida en la semifinal, por 15-10, y Kim venció a su compañero de equipo y campeón mundial Sanguk Oh, por 15-13.</p>
        <p>En la final de la prueba de sable femenino, Georgiadou derrotó a su compañera de  equipo, Theodora Gkountoura, por un solo punto, por 15-14, para hacerse con el oro. Gkountoura venció a la coreana Jisu Yoon en la semifinal, por 15-12, y Georgiadou se impuso a la rusa Svetlana Sheveleva, por 15-12. Cabe destacar que en cuartos de final Yoon venció a su compañera de equipo y campeona olímpica Jiyeon Kim, por 15-13.</p>
        <p>La clasificación final de sable masculino fue la siguiente: Junghwan Kim (KOR, oro), Luca Curatoli (ITA, plata), Sanguk Oh (KOR, bronce), Kento Yoshida (JPN, bronce), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) y Enver Yildirim (TUR).</p>
        <p>La clasificación final de sable femenino fue la siguiente: Despina Georgiadou (GRE, oro), Theodora Gkountoura (GRE, plata), Svetlana Sheveleva (RUS, bronce), Jisu Yoon (KOR, bronce), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) y Amalia Aime (FRA).</p>
        <p>Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Para tener más noticias y ver reportajes emocionantes sobre la esgrima mundial, consulte la serie de vídeos de la FIE en nuestro canal de YouTube.</p>
        <p>Haga clic aquí para volver a ver los encuentros masculinos y femeninos del Gran Premio de Sable de Orleans.</p>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim
            .fromTo(cOf("10-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("10-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("10-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("10-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg10Anim.stop();
          resetNumbers("10-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  EL COREANO KIM Y LA GRIEGA GEORGIADOU GANAN EL ORO EN EL GRAN PREMIO DE SABLE DE ORLEANS DE 2021 ORLEANS, FRANCIA 13 DE NOVIEMBRE DE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="11-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim
            .fromTo(idOf("11-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg11Anim.stop();
          resetNumbers("11-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAN PREMIO DE SABLE ORLEANS, FRANCIA 2/3  En el primer Gran Premio de la FIE de la temporada de competencias 2021-2022, el campeón mundial coreano Junghwan Kim y la griega Despina Georgiadou ganaron las pruebas individuales masculina y femenina del Gran Premio de Sable de Orleans. Las finales se celebraron en el recinto deportivo Zénith d'Orléans, y participaron en la competencia general 170 hombres y 162 mujeres. En la final de la prueba de sable masculino, Kim se enfrentó al italiano Luca Curatoli, ganando la medalla de oro por 15-3. Curatoli derrotó al japonés Kento Yoshida en la semifinal, por 1510, y Kim venció a su compañero de equipo y campeón mundial Sanguk Oh, por 15-13. En la final de la prueba de sable femenino, Georgiadou derrotó a su compañera de equipo, Theodora Gkountoura, por un solo punto, por 15-14, para hacerse con el oro. Gkountoura venció a la coreana Jisu Yoon en la semifinal, por 15-12, y Georgiadou se impuso a la rusa Svetlana Sheveleva, por 15-12. Cabe destacar que en cuartos de final Yoon venció a"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions/2022/158" target="_blank">
          <div class="addContentLink" style="bottom: 412px; right: 152px; width: 57px; height: 20px;"></div>
          <div class="addContentLink" style="bottom: 389px; right: 412px; width: 113px; height: 20px;"></div>
        </a> 
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 318px; right: 288px; width: 146px; height: 21px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo/videos" target="_blank">
          <div class="addContentLink" style="bottom: 271px; right: 407px; width: 119px; height: 21px;"></div>
        </a>

        <img id="12-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .fromTo(idOf("12-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAN PREMIO DE SABLE ORLEANS, FRANCIA 3/3  su compañera de equipo y campeona olímpica Jiyeon Kim, por 15-13. La clasificación final de sable masculino fue la siguiente: Junghwan Kim (KOR, oro), Luca Curatoli (ITA, plata), Sanguk Oh (KOR, bronce), Kento Yoshida (JPN, bronce), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) y Enver Yildirim (TUR).  Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Para tener más noticias y ver reportajes emocionantes sobre la esgrima mundial, consulte la serie de vídeos de la FIE en nuestro canal de YouTube. Haga clic aquí para volver a ver los encuentros masculinos y femeninos del Gran Premio de Sable de Orleans. ■  La clasificación final de sable femenino fue la siguiente: Despina Georgiadou (GRE, oro), Theodora Gkountoura (GRE, plata), Svetlana Sheveleva (RUS, bronce), Jisu Yoon (KOR, bronce), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) y Amalia Aime (FRA). W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:lammet@mail.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 317px; right: 113px; width: 197px; height: 24px;"></div> </a>
        <a href="https://www.lammet.ru" target="_blank">
          <div class="contentLinkNone" style="bottom: 292px; right: 177px; width: 132px; height: 24px;"></div> </a>
      `,
      "mobileHtml": `
        <a href="https://www.lammet.ru" target="_blank">
          <img src="/120/es/static/_content/13-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 14-title" style="top:70px;left:64px;" src="/120/es/static/_content/14-title-1.png">
        <img class="abs halfScale 14-sub" style="top:220px;left:97px;" src="/120/es/static/_content/14-sub-1.png">
        <img class="abs halfScale 14-line" style="top:223px;left:64px;" src="/120/es/static/_content/14-line-1.png">
        <img id="14-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup">
          La francesa Jacques Andre Coquin y el equipo ruso ganan la Copa del mundo de espada femenina «Glaive de Tallinn»</h2>
        <img src="/120/es/static/_content/14-mobile-1.jpg">
        <p><strong>Tallín, Estonia<br>19-21 de Noviembre de 2021</strong></p>
        <p>La francesa Josephine Jacques Andre Coquin ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la 51ª Copa del mundo de espada femenina «Glaive de Tallinn».  </p>
        <p>Con 246 esgrimistas de espada femenina y 26 equipos en la competición, se celebró la primera Copa del mundo senior femenina de la FIE de la temporada de competición 2021-2022. El evento se celebró en el complejo deportivo Kalev Sports Hall.</p>
        <p>En espada femenina individual, Jacques Andre Coquin se enfrentó a su compañera de equipo Marie-Florence Candassamy en el encuentro final, ganando con una puntuación de 15-11. Candassamy venció a la italiana Federica Isola en la ronda de semifinales por 15-9, y Jacques Andre Coquin derrotó a su compañera de equipo, Alexandra Louis Marie, por 15-11.</p>
        <p>En espada femenina por equipos, Rusia ganó frente a Alemania, con una puntuación de 43-37. Alemania venció a Italia en la ronda de semifinales por 32-31, y Rusia derrotó a Corea por 45-35. Italia obtuvo la medalla de bronce frente a Corea por 45-33.</p>
        <p>La clasificación final de espada femenina individual estuvo formada por Josephine Jacques Andre Coquin (FRA, oro), Marie-Florence Candassamy (FRA, plata), Federica Isola (ITA, bronce), Alexandra Louis Marie (FRA, bronce), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) y Lauren Rembi (FRA).</p>
        <p>La clasificación final de espada femenina por equipos la lideró Rusia (oro), Alemania (plata), Italia (bronce), Corea, Estonia, Suiza, Francia y Polonia.</p>
        <p>Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea los vídeos de la FIE en el Canal de esgrima de la FIE en YouTube.</p>
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim
            .fromTo(cOf("14-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("14-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("14-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("14-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg14Anim.stop();
          resetNumbers("14-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  LA FRANCESA JACQUES ANDRE COQUIN Y EL EQUIPO RUSO GANAN LA COPA DEL MUNDO DE ESPADA FEMENINA «GLAIVE DE TALLINN» TALLÍN, ESTONIA 19-21 DE NOVIEMBRE DE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="15-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim
            .fromTo(idOf("15-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE ESPADA FEMENINA TALLÍN, ESTONIA 2/3  La francesa Josephine Jacques Andre Coquin ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la 51ª Copa del mundo de espada femenina «Glaive de Tallinn». Con 246 esgrimistas de espada femenina y 26 equipos en la competición, se celebró la primera Copa del mundo senior femenina de la FIE de la temporada de competición 20212022. El evento se celebró en el complejo deportivo Kalev Sports Hall.  En espada femenina individual, Jacques Andre Coquin se enfrentó a su compañera de equipo Marie-Florence Candassamy en el encuentro final, ganando con una puntuación de 15-11. Candassamy venció a la italiana Federica Isola en la ronda de semifinales por 15-9, y Jacques Andre Coquin derrotó a su compañera de equipo, Alexandra Louis Marie, por 15-11. En espada femenina por equipos, Rusia ganó frente a Alemania, con una puntuación de 43-37. Alemania venció a Italia en la ronda de"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 271px; right: 152px; width: 282px; height: 22px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="  bottom: 200px; right: 150px; width: 147px; height: 22px;"></div>
          <div class="addContentLink"
            style="bottom: 179px; right: 347px; width: 179px; height: 22px;"></div>
        </a>

        <img id="16-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim
            .fromTo(idOf("16-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE ESPADA FEMENINA TALLÍN, ESTONIA 3/3  semifinales por 32-31, y Rusia derrotó a Corea por 45-35. Italia obtuvo la medalla de bronce frente a Corea por 45-33. La clasificación final de espada femenina individual estuvo formada por Josephine Jacques Andre Coquin (FRA, oro), MarieFlorence Candassamy (FRA, plata), Federica Isola (ITA, bronce), Alexandra Louis Marie (FRA, bronce), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) y Lauren Rembi (FRA). La clasificación final de espada femenina por equipos la lideró Rusia (oro), Alemania (plata), Italia (bronce), Corea, Estonia, Suiza, Francia y Polonia. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea los vídeos de la FIE en el Canal de esgrima de la FIE en YouTube. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 17-title" style="top:57px;left:66px;" src="/120/es/static/_content/17-title-1.png">
        <img class="abs halfScale 17-sub" style="top:216px;left:97px;" src="/120/es/static/_content/17-sub-1.png">
        <img class="abs halfScale 17-line" style="top:214px;left:64px;" src="/120/es/static/_content/17-line-1.png">
        <img id="17-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup">
          El venezolano Limardo Gascón y el equipo de Rusia ganan la Copa del mundo de espada masculina en Berna</h2>
        <img src="/120/es/static/_content/17-mobile-1.jpg">
        <p>​​<strong>Berna, Suiza<br>19-21 de noviembre de 2021</strong></p>
        <p><strong>El campeón olímpico de Venezuela Rubén Limardo Gascón ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la Copa del mundo de espada masculina de Berna. </strong></p>
        <p>Con 265 esgrimistas de espada y 33 equipos en la competición, se celebró la primera Copa del mundo senior masculina de la FIE de la temporada de competición 2021-2022. El evento se celebró en el estadio Wankdorf de Berna.</p>
        <p>En espada masculina individual, Limardo Gascón se enfrentó al francés Alexandre Bardenet en el encuentro final, ganando con una puntuación de 15-7. Bardenet derrotó a su compañero de equipo y medallista olímpico de oro Romain Cannone en la ronda de semifinales por 15-9, y Limardo Gascón venció al italiano Andrea Santarelli por un solo toque, con una puntuación de 10-9. Bardenet también ganó a su compañero de equipo y campeón mundial Yannick Borel en cuartos de final por 15-9.</p>
        <p>En espada masculina por equipos, Rusia ganó por un solo punto frente a España, con una puntuación de 45-44. España venció a Hungría en la ronda de semifinales por 45-42, y Rusia derrotó a Japón por 45-34. Japón obtuvo la medalla de bronce frente a Hungría por 45-34.</p>
        <p>La clasificación final de espada masculina individual estuvo compuesta por Rubén Limardo Gascón (VEN, oro), Alexandre Bardenet (FRA, plata), Romain Cannone (FRA, bronce), Andrea Santarelli (ITA, bronce), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) y Georgiy Bruev (RUS).</p>
        <p>La clasificación final de espada masculina por equipos estuvo liderada por Rusia (oro), España (plata), Japón (bronce), Hungría, Francia, Ucrania, Dinamarca e Italia.</p>
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim
            .fromTo(cOf("17-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("17-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("17-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("17-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  EL VENEZOLANO LIMARDO GASCÓN Y EL EQUIPO DE RUSIA GANAN LA COPA DEL MUNDO DE ESPADA MASCULINA EN BERNA BERNA, SUIZA 19-21 DE NOVIEMBRE DE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="18-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim
            .fromTo(idOf("18-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE ESPADA MASCULINA BERNA, SUIZA 2/2  VeEl campeón olímpico de Venezuela Rubén Limardo Gascón ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la Copa del mundo de espada masculina de Berna. Con 265 esgrimistas de espada y 33 equipos en la competición, se celebró la primera Copa del mundo senior masculina de la FIE de la temporada de competición 2021-2022. El evento se celebró en el estadio Wankdorf de Berna. En espada masculina individual, Limardo Gascón se enfrentó al francés Alexandre Bardenet en el  encuentro final, ganando con una puntuación de 15-7. Bardenet derrotó a su compañero de equipo y medallista olímpico de oro Romain Cannone en la ronda de semifinales por 159, y Limardo Gascón venció al italiano Andrea Santarelli por un solo toque, con una puntuación de 10-9. Bardenet también ganó a su compañero de equipo y campeón mundial Yannick Borel en cuartos de final por 15-9. En espada masculina por equipos, Rusia ganó por un solo punto frente a España, con una puntuación de 45-44. España venció a Hungría en la ronda de semifinales por 45-42, y Rusia derrotó a Japón por 45-34. Japón obtuvo la medalla de bronce frente a Hungría por 45-34. La clasificación final de espada masculina individual estuvo compuesta por Rubén Limardo Gascón (VEN, oro), Alexandre Bardenet (FRA, plata), Romain Cannone (FRA, bronce), Andrea Santarelli (ITA, bronce), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) y Georgiy Bruev (RUS). La clasificación final de espada masculina por equipos estuvo liderada por Rusia (oro), España (plata), Japón (bronce), Hungría, Francia, Ucrania, Dinamarca e Italia. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/es/static/_content/19-mobile-1.jpg">
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 20-title" style="top:64px;left:487px;" src="/120/es/static/_content/20-title-1.png">
        <img class="abs halfScale 20-sub" style="top:263px;left:519px;" src="/120/es/static/_content/20-sub-1.png">
        <img class="abs halfScale 20-line" style="top:266px;left:487px;" src="/120/es/static/_content/20-line-1.png">
        <img id="20-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup">
          La italiana Alice Volpi y el equipo de Italia ganan el oro en la Copa del Mundo de florete femenino
        </h2>
        <img src="/120/es/static/_content/20-mobile-1.jpg">
        <p><strong>Saint-Maur-Des-Fossés, Francia<br>10-12 de diciembre de 2021 </strong></p>
        <p><strong>La campeona del mundo Alice Volpi ganó la medalla de oro individual e Italia se llevó el oro en la prueba por equipos de la Copa del Mundo de florete femenino de Saint Maur.</strong></p>
        <p>La prueba se celebró en el Centro Deportivo Pierre Brossolette con la participación de 182 esgrimistas de florete femenino y 20 equipos.</p>
        <p>Volpi se enfrentó a la campeona olímpica estadounidense Lee Kiefer en el encuentro por la medalla de oro en florete femenino individual, ganando por un solo toque, por 15-14. Kiefer venció a su compañera de equipo, Jacqueline Dubrovich, en la ronda de semifinales, por 15-4, y Volpi también derrotó a su compañera de equipo, Francesca Palumbo, por 15-12.</p>
        <p>En la prueba de florete femenino por equipos, Italia se llevó la medalla de oro contra Japón en la ronda final y ganó con un resultado de 43-40. Japón venció a Rusia en las semifinales, por 31-26, e Italia derrotó a Canadá, por 45-37. La medalla de bronce fue para Rusia tras derrotar a Canadá, por 44-39.</p>
        <p>La clasificación en la prueba de florete femenino individual incluía a Alice Volpi (ITA, oro), Lee Kiefer (EE. UU, plata), Jacqueline Dubrovich (EE. UU, bronce), Francesca Palumbo (ITA, bronce), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) y Kiyeun Kim (KOR).</p>
        <p>La clasificación en la prueba de florete femenino por equipos incluía a Italia (oro), Japón (plata), Rusia (bronce), Canadá, Polonia, China, EE. UU. y Hong Kong, China.</p>
        <p>Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Consulte el canal de esgrima de la FIE en YouTube para ver más noticias y reportajes sobre la esgrima mundial.</p>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim
            .fromTo(cOf("20-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("20-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("20-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("20-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  LA ITALIANA ALICE VOLPI Y EL EQUIPO DE ITALIA GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE FEMENINO SAINT-MAUR-DES-FOSSÉS, FRANCIA 10-12 DE DICIEMBRE DE 2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 131px; right: 151px; width: 142px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 107px; right: 404px; width: 122px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="  bottom: 107px; right: 150px; width: 149px; height: 20px;"></div>
          <div class="addContentLink" style="  bottom: 84px; right: 347px; width: 179px; height: 20px;"></div>
        </a>

        <img id="21-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim
            .fromTo(idOf("21-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LA COPA DEL MUNDO DE FLORETE FEMENINO SAINT-MAUR-DESFOSSÉS, FRANCIA 2/2  La campeona del mundo Alice Volpi ganó la medalla de oro individual e Italia se llevó el oro en la prueba por equipos de la Copa del Mundo de florete femenino de Saint Maur. La prueba se celebró en el Centro Deportivo Pierre Brossolette con la participación de 182 esgrimistas de florete femenino y 20 equipos. Volpi se enfrentó a la campeona olímpica estadounidense Lee Kiefer en el encuentro por la medalla de oro en florete femenino individual, ganando por un solo toque, por 15-14. Kiefer venció a su compañera de equipo, Jacqueline Dubrovich, en la ronda de semifinales, por 154, y Volpi también derrotó a su compañera de equipo, Francesca Palumbo, por 15-12. En la prueba de florete femenino por equipos, Italia se llevó la medalla de oro contra Japón en la ronda final y ganó con un resultado de 4340. Japón venció a Rusia en las semifinales, por 31-26, e Italia derrotó a Canadá, por 4537. La medalla de bronce fue para Rusia tras derrotar a Canadá, por 44-39. La clasificación en la prueba de florete femenino individual incluía a Alice Volpi (ITA, oro),  Lee Kiefer (EE. UU, plata), Jacqueline Dubrovich (EE. UU, bronce), Francesca Palumbo (ITA, bronce), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) y Kiyeun Kim (KOR). La clasificación en la prueba de florete femenino por equipos incluía a Italia (oro), Japón (plata), Rusia (bronce), Canadá, Polonia, China, EE. UU. y Hong Kong, China. Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Consulte el canal de esgrima de la FIE en YouTube para ver más noticias y reportajes sobre la esgrima mundial. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 22-title" style="top:85px;left:363px;" src="/120/es/static/_content/22-title-1.png">
        <img class="abs halfScale 22-sub" style="top:285px;left:396px;" src="/120/es/static/_content/22-sub-1.png">
        <img class="abs halfScale 22-line" style="top:287px;left:363px;" src="/120/es/static/_content/22-line-1.png">
        <img id="22-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup">
          Cheung de Hong Kong e Italia por equipos ganan el oro en la Copa del mundo de florete masculino de París</h2>
        <img src="/120/es/static/_content/22-mobile-1.jpg">
        <p><strong>París, Francia<br>14-16 de Enero de 2022</strong></p>
        <p><strong>El campeón olímpico de Hong Kong Ka Long Cheung ganó la medalla de oro individual e Italia obtuvo el oro en la competición por equipos en la Copa del mundo de florete masculino del Challenge Internacional (CIP) de París. </strong></p>
        <p>En el evento, que se celebró en el Stade Pierre de Coubertin, participaron 210 tiradores y 26 equipos.</p>
        <p>Cheung se enfrentó al italiano Edoardo Luperi en la ronda final de florete masculino individual, ganando el oro con una puntuación de 15-12. Luperi derrotó al estadounidense Chase Emmer en la ronda de semifinales por 15-13, mientras que Cheung ganó al campeón del mundo italiano Alessio Foconi, por 15-4. Cheung también ganó frente al campeón del mundo francés Enzo Lefort en los cuartos de final por 15-9, y en la misma ronda Emmer venció al campeón olímpico italiano Daniele Garozzo por 15-5.</p>
        <p>Italia logró el oro en florete masculino por equipos, derrotando a Francia en el encuentro final por 45-20. Francia venció a Rusia en la ronda de semifinales por 45-39, mientras que Italia venció a EE. UU. por 45-38. EE. UU. obtuvo la medalla de bronce frente a Rusia por 45-31.</p>
        <p>La clasificación final de florete masculino individual estuvo compuesta por Ka Long Cheung (HKG, oro), Edoardo Luperi (ITA, plata), Chase Emmer (EE. UU., bronce), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) y Alexandre Sido (FRA).</p>
        <p>La clasificación final de florete masculino por equipos estuvo liderada por Italia (oro), Francia (plata), EE. UU. (bronce), Rusia, Japón, Egipto, Corea y Hong Kong, China.</p>
        <p>Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim
            .fromTo(cOf("22-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("22-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("22-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("22-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  CHEUNG DE HONG KONG E ITALIA POR EQUIPOS GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE MASCULINO DE PARÍS PARÍS, FRANCIA 14-16 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 131px; right: 193px; width: 249px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink" style="bottom: 85px; right: 149px; width: 77px; height: 20px;"></div>
          <div class="addContentLink" style="  bottom: 60px; right: 283px; width: 243px; height: 21px;"></div>
        </a>

        <img id="23-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim
            .fromTo(idOf("23-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE FLORETE MASCULINO PARÍS, FRANCIA 2/2  El campeón olímpico de Hong Kong Ka Long Cheung ganó la medalla de oro individual e Italia obtuvo el oro en la competición por equipos en la Copa del mundo de florete masculino del Challenge Internacional (CIP) de París. En el evento, que se celebró en el Stade Pierre de Coubertin, participaron 210 tiradores y 26 equipos. Cheung se enfrentó al italiano Edoardo Luperi en la ronda final de florete masculino individual, ganando el oro con una puntuación de 15-12. Luperi derrotó al estadounidense Chase Emmer en la ronda de semifinales por 15-13, mientras que Cheung ganó al campeón del mundo italiano Alessio Foconi, por 15-4. Cheung también ganó frente al campeón del mundo francés Enzo Lefort en los cuartos de final por 15-9, y en la misma ronda Emmer venció al campeón olímpico italiano Daniele Garozzo por 15-5. Italia logró el oro en florete masculino por equipos, derrotando a Francia en el encuentro final por 45-20. Francia venció a Rusia en la ronda de semifinales por 45-39, mientras  que Italia venció a EE. UU. por 45-38. EE. UU. obtuvo la medalla de bronce frente a Rusia por 45-31. La clasificación final de florete masculino individual estuvo compuesta por Ka Long Cheung (HKG, oro), Edoardo Luperi (ITA, plata), Chase Emmer (EE. UU., bronce), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) y Alexandre Sido (FRA). La clasificación final de florete masculino por equipos estuvo liderada por Italia (oro), Francia (plata), EE. UU. (bronce), Rusia, Japón, Egipto, Corea y Hong Kong, China. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <div class="contentLinkNone" style="  bottom: 173px; right: 981px; width: 177px; height: 25px; }"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <img src="/120/es/static/_content/pg24.jpg">
        </a>
      `,  
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:60px;left:486px;" src="/120/es/static/_content/25-title-1.png">
        <img class="abs halfScale 25-sub" style="top:243px;left:770px;" src="/120/es/static/_content/25-sub-1.png">
        <img class="abs halfScale 25-line" style="top:241px;left:738px;" src="/120/es/static/_content/25-line-1.png">
        <img id="25-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup">
          El italiano Volpi y EE. UU. por equipos ganan el oro en la Copa del mundo de florete femenino</h2>
        <p><strong>Poznan, Polonia<br>14-16 de enero de 2022</strong></p>
        <img src="/120/es/static/_content/25-mobile-1.jpg">
        <p><strong>La campeona del mundo italiana Alice Volpi obtuvo la medalla de oro individual, y EE. UU. ganó el oro por equipos en la Copa del mundo de florete femenino de la Universidad Adam Mickiewicz, Polonia. </strong></p>
        <p>En el evento, que se celebró en el UAM Sport Center, participaron 180 tiradores y 20 equipos.</p>
        <p>En la ronda final de florete femenino individual, Volpi se enfrentó a la canadiense Eleanor Harvey, ganando el oro con una puntuación de 15-10. En la ronda de semifinales, Harvey venció a la china Qingyuan Chen por 15-7, y Volpi derrotó a la compañera de equipo Martina Favaretto por 15-11.</p>
        <p>En florete femenino por equipos, EE. UU. derrotó a Japón en el encuentro final, ganando el oro con una puntuación de 45-23. Japón ganó frente a Polonia en semifinales por 27-25 y EE. UU. venció a Rusia por 45-39. Polonia se llevó la medalla de bronce tras su victoria frente a Rusia por 44-42.</p>
        <p>La clasificación de florete femenino individual estuvo compuesta por Alice Volpi (ITA, oro), Eleanor Harvey (CAN, plata), Martina Favaretto (ITA, bronce), Qingyuan Chen (CHN, bronce), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) y Elena Petrova (RUS).</p>
        <p>La clasificación de florete femenino por equipos estuvo liderada por EE. UU. (oro), Japón (plata), Polonia (bronce), Rusia, Italia, China, Francia y Canadá.</p>
        <p>Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim
            .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("25-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("25-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("25-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
        
        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  EL ITALIANO VOLPI Y EE. UU. POR EQUIPOS GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE FEMENINO POZNAN, POLONIA 14-16 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 130px; right: 192px; width: 249px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="  bottom: 85px; right: 149px; width: 79px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 60px; right: 282px; width: 244px; height: 21px;"></div>
        </a>

        <img id="26-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim
            .fromTo(idOf("26-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE FLORETE FEMENINO POZNAN, POLONIA 2/2  La campeona del mundo italiana Alice Volpi obtuvo la medalla de oro individual, y EE. UU. ganó el oro por equipos en la Copa del mundo de florete femenino de la Universidad Adam Mickiewicz, Polonia. En el evento, que se celebró en el UAM Sport Center, participaron 180 tiradores y 20 equipos. En la ronda final de florete femenino individual, Volpi se enfrentó a la canadiense Eleanor Harvey, ganando el oro con una puntuación de 15-10. En la ronda de semifinales, Harvey venció a la china Qingyuan Chen por 15-7,  y Volpi derrotó a la compañera de equipo Martina Favaretto por 15-11. En florete femenino por equipos, EE. UU. derrotó a Japón en el encuentro final, ganando el oro con una puntuación de 45-23. Japón ganó frente a Polonia en semifinales por 2725 y EE. UU. venció a Rusia por 45-39. Polonia se llevó la medalla de bronce tras su victoria frente a Rusia por 44-42. La clasificación de florete femenino individual estuvo compuesta por Alice Volpi (ITA, oro), Eleanor Harvey (CAN, plata), Martina Favaretto (ITA, bronce), Qingyuan Chen (CHN, bronce), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) y Elena Petrova (RUS). La clasificación de florete femenino por equipos estuvo liderada por EE. UU. (oro), Japón (plata), Polonia (bronce), Rusia, Italia, China, Francia y Canadá. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 27-title" style="top:64px;left:454px;" src="/120/es/static/_content/27-title-1.png">
        <img class="abs halfScale 27-sub" style="top:265px;left:487px;" src="/120/es/static/_content/27-sub-1.png">
        <img class="abs halfScale 27-line" style="top:262px;left:454px;" src="/120/es/static/_content/27-line-1.png">
        <img id="27-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
      <h2
        id="georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup">
        Bazadze, Queroli, y los equipos de Corea y Francia ganan el oro en la Copa del mundo de sable</h2>
        <p><strong>Tbilisi, Georgia<br>14-18 de enero de 2022</strong></p>
        <img src="/120/es/static/_content/27-mobile-1.jpg">
        <p><strong>Sandro Bazadze de Georgia y Caroline Queroli de Francia obtuvieron las medallas de oro individuales, ganando Corea y Francia las competiciones masculinas y femeninas por equipos en la Copa del mundo de sable en Tbilisi. </strong></p>
        <p>En el evento, que se celebró en el Palacio Olímpico, compitieron 188 hombres y 154 mujeres, así como 24 equipos masculinos y 25 equipos femeninos.</p>
        <p>Bazadze se enfrentó al ruso Kamil Ibragimov en el encuentro final de sable masculino individual, al que ganó con una puntuación de 15-8. Ibragimov venció al campeón mundial coreano Junghwan Kim en la ronda de semifinales por 15-12, mientras que Bazadze ganó frente al francés Bolade Apithy, por 15-10. Apithy derrotó al campeón mundial coreano Sanguk Oh en los cuartos de final por 15-8, y Kim ganó al campeón mundial húngaro Andras Szatmari en la misma ronda por 15-12.</p>
        <p>Queroli ganó frente a la griega Theodora Gkountoura en el encuentro final de sable femenino individual por 15-12. Gkountoura venció a la campeona olímpica rusa Yana Egorian en semifinales por 15-14, mientras que Queroli derrotó a la italiana Rossella Gregorio por 15-14.</p>
        <p>En sable masculino por equipos, Corea ganó frente a Alemania en el encuentro final por 45-38. Alemania venció a Italia en la ronda de semifinales por 45-43, mientras que Corea venció a Rusia por 45-44. La medalla de bronce fue para Rusia después de ganar a Italia por 45-40.</p>
        <p>En sable femenino por equipos, Francia consiguió la medalla de oro ganando frente a Corea en la final por 45-35. Francia venció a España en la ronda de semifinales por 45-34, mientras que Corea venció a Rusia por 45-39. La medalla de bronce fue para Rusia después de vencer a España por 45-43.</p>
        <p>La clasificación final de sable masculino individual estuvo compuesta por Sandro Bazadze (GEO, oro), Kamil Ibragimov (RUS, plata), Bolade Apithy (FRA, bronce), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) y Giovanni Repetti (ITA).</p>
        <p>La clasificación final de sable femenino individual estuvo compuesta por Caroline Queroli (FRA, oro), Theodora Gkountoura (GRE, plata), Yana Egorian (RUS, bronce), Rossella Gregorio (ITA, bronce), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) y Seri Ozaki (JPN).</p>
        <p>La clasificación final de sable masculino por equipos estuvo liderada por Corea (oro), Alemania (plata), Rusia (bronce), Italia, Irán, Egipto, Hungría y Francia.</p>
        <p>La clasificación final de sable femenino por equipos estuvo liderada por Francia (oro), Corea (plata), Rusia (bronce), España, Italia, Bulgaria, Hungría y Polonia.</p>
        <p>Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim
            .fromTo(cOf("27-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("27-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("27-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("27-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  BAZADZE, QUEROLI, Y LOS EQUIPOS DE COREA Y FRANCIA GANAN EL ORO EN LA COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 14-18 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="28-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim
            .fromTo(idOf("28-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 2/3  Sandro Bazadze de Georgia y Caroline Queroli de Francia obtuvieron las medallas de oro individuales, ganando Corea y Francia las competiciones masculinas y femeninas por equipos en la Copa del mundo de sable en Tbilisi. En el evento, que se celebró en el Palacio Olímpico, compitieron 188 hombres y 154 mujeres, así como 24 equipos masculinos y 25 equipos femeninos. Bazadze se enfrentó al ruso Kamil Ibragimov en el encuentro final de sable masculino individual, al que ganó con una puntuación de 15-8. Ibragimov venció al campeón mundial coreano Junghwan Kim en la ronda de semifinales por 15-12, mientras que Bazadze ganó frente al francés Bolade Apithy, por 15-10. Apithy derrotó al campeón mundial coreano Sanguk Oh en los cuartos de final por 15-8, y Kim ganó al campeón mundial húngaro Andras Szatmari en la misma ronda por 15-12. Queroli ganó frente a la griega Theodora Gkountoura en el encuentro final de sable femenino individual por 15-12. Gkountoura venció a la campeona olímpica rusa Yana  Egorian en semifinales por 15-14, mientras que Queroli derrotó a la italiana Rossella Gregorio por 15-14. En sable masculino por equipos, Corea ganó frente a Alemania en el encuentro final por 45-38. Alemania venció a Italia en la ronda de semifinales por 45-43, mientras que Corea venció a Rusia por 45-44. La medalla de bronce fue para Rusia después de ganar a Italia por 45-40."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="bottom: 201px; right: 153px; width: 279px; height: 20px;"></div>
        </a> 
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 131px; right: 166px; width: 310px; height: 20px;"></div>
        </a>

        <img id="29-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim
            .fromTo(idOf("29-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 3/3  En sable femenino por equipos, Francia consiguió la medalla de oro ganando frente a Corea en la final por 45-35. Francia venció a España en la ronda de semifinales por 45-34, mientras que Corea venció a Rusia por 45-39. La medalla de bronce fue para Rusia después de vencer a España por 45-43. La clasificación final de sable masculino individual estuvo compuesta por Sandro Bazadze (GEO, oro), Kamil Ibragimov (RUS, plata), Bolade Apithy (FRA, bronce), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) y Giovanni Repetti (ITA). La clasificación final de sable femenino individual estuvo compuesta por Caroline Queroli (FRA, oro), Theodora Gkountoura (GRE, plata), Yana Egorian (RUS, bronce), Rossella Gregorio (ITA, bronce), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) y Seri Ozaki (JPN). La clasificación final de sable masculino por equipos estuvo liderada por Corea (oro),  Alemania (plata), Rusia (bronce), Italia, Irán, Egipto, Hungría y Francia. La clasificación final de sable femenino por equipos estuvo liderada por Francia (oro), Corea (plata), Rusia (bronce), España, Italia, Bulgaria, Hungría y Polonia. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1095px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://www.instagram.com/uhlmann.fencing/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 1074px; width: 19px; height: 18px;"></div>
        </a>
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <div class="contentLinkNone" style="bottom: 39px; right: 966px; width: 104px; height: 18px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://uhlmann-fechtsport.com/en/" target="_blank">
          <img src="/120/es/static/_content/30-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 31-title" style="top:65px;left:64px;" src="/120/es/static/_content/31-title-1.png">
        <img class="abs halfScale 31-sub" style="top:148px;left:621px;" src="/120/es/static/_content/31-sub-1.png">
        <img class="abs halfScale 31-line" style="top:145px;left:588px;" src="/120/es/static/_content/31-line-1.png">
        <img id="31-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup">
          Bashta y el equipo de Francia ganan el oro en la Copa del mundo de sable femenino en Plovdiv</h2>
        <img src="/120/es/static/_content/31-mobile-1.jpg">
        <p><strong>Plovdiv, Bulgaria<br>28-30 de enero de 2022</strong></p>
        <p><strong>Anna Bashta de Azerbaiyán y el equipo de Francia obtienen las medallas de oro en la Copa del mundo de sable femenino en Plovdiv, Bulgaria. </strong></p>
        <p>En el evento, que se celebró en el Complex SILA, participaron 136 mujeres esgrimistas de sable y 20 equipos.</p>
        <p>Bashta se enfrentó a la francesa Manon Apithy-Brunet en la ronda final de la prueba individual, ganando con una puntuación de 15-10. Apithy-Brunet venció a su compañera de equipo, Malina Vongsavady, en semifinales por 15-9 y Bashta derrotó a la italiana Rossella Gregorio por 15-13.</p>
        <p>En la competición de sable femenino por equipos, Francia derrotó a Azerbaiyán en el encuentro final por 45-39. Azerbaiyán ganó frente a Bulgaria en semifinales por 45-32, y Francia venció a Italia por 45-23. Italia ganó la medalla de bronce frente a Bulgaria por 45-29.</p>
        <p>La clasificación de sable femenino individual estuvo compuesta por Anna Bashta (AZE, oro), Manon Apithy-Brunet (FRA, plata), Rossella Gregorio (ITA, bronce), Malina Vongsavady (FRA, bronce), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) y Svetlana Sheveleva (RUS).</p>
        <p>La clasificación de sable femenino por equipos estuvo liderada por Francia (oro), Azerbaiyán (plata), Italia (bronce), Bulgaria, Hungría, España, Turquía y Alemania.</p>
        <p>Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim
            .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("31-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("31-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("31-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  BASHTA Y EL EQUIPO DE FRANCIA GANAN EL ORO EN LA COPA DEL MUNDO DE SABLE PLOVDIV, BULGARIA FEMENINO EN PLOVDIV 28-30 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 130px; right: 193px; width: 207px; height: 20px;"></div>
        </a>
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="  bottom: 84px; right: 150px; width: 77px; height: 20px;"></div>
          <div class="addContentLink"
            style="  bottom: 59px; right: 282px; width: 243px; height: 22px;"></div>
        </a>

        <img id="32-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim
            .fromTo(idOf("32-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "COPA DEL MUNDO DE SABLE FEMENINO PLOVDIV, BULGARIA 2/2  Anna Bashta de Azerbaiyán y el equipo de Francia obtienen las medallas de oro en la Copa del mundo de sable femenino en Plovdiv, Bulgaria. En el evento, que se celebró en el Complex SILA, participaron 136 mujeres esgrimistas de sable y 20 equipos. Bashta se enfrentó a la francesa Manon Apithy-Brunet en la ronda final de la prueba individual, ganando con una puntuación de 15-10. Apithy-Brunet venció a su compañera de equipo, Malina Vongsavady, en semifinales por 15-9 y Bashta derrotó a la italiana Rossella Gregorio por 15-13. En la competición de sable femenino por equipos, Francia derrotó a Azerbaiyán en el encuentro final por 45-39. Azerbaiyán ganó frente a Bulgaria en semifinales por  45-32, y Francia venció a Italia por 45-23. Italia ganó la medalla de bronce frente a Bulgaria por 45-29. La clasificación de sable femenino individual estuvo compuesta por Anna Bashta (AZE, oro), Manon Apithy-Brunet (FRA, plata), Rossella Gregorio (ITA, bronce), Malina Vongsavady (FRA, bronce), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) y Svetlana Sheveleva (RUS). La clasificación de sable femenino por equipos estuvo liderada por Francia (oro), Azerbaiyán (plata), Italia (bronce), Bulgaria, Hungría, España, Turquía y Alemania. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 33-title" style="top:65px;left:395px;" src="/120/es/static/_content/33-title-1.png">
        <img class="abs halfScale 33-sub" style="top:264px;left:426px;" src="/120/es/static/_content/33-sub-1.png">
        <img class="abs halfScale 33-line" style="top:263px;left:394px;" src="/120/es/static/_content/33-line-1.png">
        <img id="33-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix">Borel de Francia y Lehis de Estonia ganan los Grandes Premios de espada de Qatar</h2>
        <img src="/120/es/static/_content/33-mobile-1.jpg">
        <p><strong>Doha, Qatar<br>28-30 de enero de 2022</strong></p>
        <p><strong>El campeón del mundo de Francia, Yannick Borel, y Katrina Lehis de Estonia obtuvieron medallas de oro individuales en los Grandes Premios de espada de 2022 en Doha, Qatar. </strong></p>
        <p>En el evento, que se celebró en el complejo deportivo Aspire Zone/Aspire Dome, compitieron 161 hombres y 120 mujeres.</p>
        <p>En el encuentro final de espada masculina individual, Borel se enfrentó al compañero de equipo Aymerick Gally, al que ganó con una puntuación de 15-10. Gally venció al italiano Federico Vismara en las semifinales por 15-6, y Borel derrotó al italiano Davide Di Veroli por 15-9. Cabe destacar que el campeón olímpico francés Romain Cannone perdió en cuartos de final frente a Borel, por 15-5, y el campeón del mundo húngaro Gergely Siklosi perdió frente a Di Veroli en la ronda 16 por 15-12.</p>
        <p>En espada femenina individual, Lehis ganó la ronda final frente a su compañera de equipo Nelli Differt, por 15-11. Differt venció a otra compañera de equipo, Erika Kirpu, en la ronda de semifinales por 12-11, y Lehis ganó frente a la francesa Marie-Florence Candassamy por 15-14. Cabe destacar que Candassamy venció a la campeona olímpica ucraniana Yana Shemyakina en cuartos de final por 15-9.</p>
        <p>La clasificación final de espada masculina estuvo compuesta por Yannick Borel (FRA, oro), Aymerick Gally (FRA, plata), Davide Di Veroli (ITA, bronce), Federico Vismara (ITA, bronce), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) y Volodymyr Stankevych (UKR).</p>
        <p>La clasificación final de espada femenina estuvo compuesta por Katrina Lehis (EST, oro), Nelli Differt (EST, plata), Marie-Florence Candassamy (FRA, bronce), Erika Kirpu (EST, bronce), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) y Yana Shemyakina (UKR).</p>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim
            .fromTo(cOf("33-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("33-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("33-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("33-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  BOREL DE FRANCIA Y LEHIS DE ESTONIA GANAN LOS GRANDES PREMIOS DE ESPADA DE QATAR DOHA, QATAR 28-30 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="34-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim
            .fromTo(idOf("34-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("34-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRANDES PREMIOS DE ESPADA DOHA, QATAR 2/2  El campeón del mundo de Francia, Yannick Borel, y Katrina Lehis de Estonia obtuvieron medallas de oro individuales en los Grandes Premios de espada de 2022 en Doha, Qatar. En el evento, que se celebró en el complejo deportivo Aspire Zone/Aspire Dome, compitieron 161 hombres y 120 mujeres. En el encuentro final de espada masculina individual, Borel se enfrentó al compañero de equipo Aymerick Gally, al que ganó con una puntuación de 15-10. Gally venció al italiano Federico Vismara en las semifinales por 15-6, y Borel derrotó al italiano Davide Di Veroli por 15-9. Cabe destacar que el campeón olímpico francés Romain Cannone perdió en cuartos de final frente a Borel, por 15-5, y el campeón del mundo húngaro Gergely Siklosi perdió frente a Di Veroli en la ronda 16 por 15-12. En espada femenina individual, Lehis ganó la ronda final frente a su compañera de equipo Nelli Differt, por 15-11. Differt venció a otra compañera de equipo, Erika Kirpu, en la ronda de semifinales por 12-11, y Lehis ganó frente a la francesa Marie-Florence Candassamy  por 15-14. Cabe destacar que Candassamy venció a la campeona olímpica ucraniana Yana Shemyakina en cuartos de final por 15-9. La clasificación final de espada masculina estuvo compuesta por Yannick Borel (FRA, oro), Aymerick Gally (FRA, plata), Davide Di Veroli (ITA, bronce), Federico Vismara (ITA, bronce), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) y Volodymyr Stankevych (UKR). La clasificación final de espada femenina estuvo compuesta por Katrina Lehis (EST, oro), Nelli Differt (EST, plata), Marie-Florence Candassamy (FRA, bronce), Erika Kirpu (EST, bronce), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) y Yana Shemyakina (UKR). ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 35-title" style="top:88px;left:381px;" src="/120/es/static/_content/35-title-1.png">
        <img class="abs halfScale 35-sub" style="top:231px;left:410px;" src="/120/es/static/_content/35-sub-1.png">
        <img class="abs halfScale 35-line" style="top:234px;left:378px;" src="/120/es/static/_content/35-line-1.png">
        <img id="35-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2 id="men-s-and-women-s-epee-grand-prix-in-budapest">Gran Premio de espada masculina y femenina en Budapest</h2>
        <img src="/120/es/static/_content/35-mobile-1.jpg">
        <p><strong>Budapest, Hungría<br>4–6 Marzo 2022</strong></p>
        <p><strong>El tricampeón olímpico húngaro Aron Szilagyi ganó la medalla de oro individual y Hungría se llevó la medalla de oro masculina por equipos en la Copa del mundo de sable masculino de Budapest.  </strong></p>
        <p>Denominadas en concreto la Copa del mundo individual «Gerevich-Kovács-Kárpáti» y la Copa del mundo por equipos «Zarándi Csaba», el evento general incluyó la participación de 204 esgrimistas individuales y 23 equipos, y se celebró en el City’s BOK Hall (anteriormente, SYMA Hall). </p>
        <p>Szilagyi se enfrentó al italiano Luca Curatoli en el encuentro final por la medalla de oro de la prueba de sable masculino individual, al que ganó con una puntuación de 15-7. En la ronda de semifinales, Curatoli venció al campeón mundial coreano Sanguk Oh por 15-8, mientras que Szilagyi ganó frente al campeón mundial coreano Junghwan Kim, por 15-14.</p>
        <p>En la prueba de sable masculino por equipos, Hungría ganó la medalla de oro frente a Francia en la ronda final con una puntuación de 45-38. Francia venció a Alemania en semifinales por 45-40, y Hungría derrotó a Rumanía por 45-30. La medalla de bronce fue para Alemania después de ganar a Rumanía por 45-43. 
        </p>
        <p>La clasificación final de sable masculino individual estuvo compuesta por Aron Szilagyi (HUN, oro), Luca Curatoli (ITA, plata), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR, bronce), Bolade Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) y Matyas Szabo (GER). </p>
        <p>La clasificación final de sable masculino por equipos estuvo liderada por Hungría (oro), Francia (plata), Alemania (bronce), Rumanía, Corea, EE. UU., Italia e Irán.</p>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim
            .fromTo(cOf("35-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("35-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("35-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("35-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg35Anim.stop();
          resetNumbers("35-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA EN BUDAPEST BUDAPEST, HUNGRÍA 4–6 MARZO 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="36-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim
            .fromTo(idOf("36-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg36Anim.stop();
          resetNumbers("36-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAN PREMIO DE ESPADA BUDAPEST, HUNGRÍA 2/3  El tricampeón olímpico húngaro Aron Szilagyi ganó la medalla de oro individual y Hungría se llevó la medalla de oro masculina por equipos en la Copa del mundo de sable masculino de Budapest. Denominadas en concreto la Copa del mundo individual «Gerevich-Kovács-Kárpáti» y la Copa del mundo por equipos «Zarándi Csaba», el evento general incluyó la participación de 204 esgrimistas individuales y 23 equipos, y se celebró en el City’s BOK Hall (anteriormente, SYMA Hall).  Szilagyi se enfrentó al italiano Luca Curatoli en el encuentro final por la medalla de oro de la prueba de sable masculino individual, al que ganó con una puntuación de 15-7. En la ronda de semifinales, Curatoli venció al campeón mundial coreano Sanguk Oh por 15-8, mientras que Szilagyi ganó frente al campeón mundial coreano Junghwan Kim, por 15-14. En la prueba de sable masculino por equipos, Hungría ganó la medalla de oro frente a Francia en la ronda final con una puntuación de 45-38. Francia venció a Alemania en semifinales por 45-40, y Hungría derrotó a Rumanía por 45-30. La medalla de bronce fue para Alemania después de ganar a Rumanía por 45-43."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <!-- <a href="https://fie.org/competitions" target="_blank">
          <div class="addContentLink"
            style="  bottom: 624px; right: 156px; width: 114px; height: 20px; "></div>
        </a> -->
        
        <a href="https://www.youtube.com/c/FIEvideo" target="_blank">
          <div class="addContentLink"
            style="bottom: 577px; right: 152px; width: 111px; height: 20px;"></div>
          <div class="addContentLink"
            style="bottom: 554px; right: 388px; width: 139px; height: 20px;"></div>
        </a>

        <img id="37-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim
            .fromTo(idOf("37-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop();
          resetNumbers("37-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "GRAN PREMIO DE ESPADA BUDAPEST, HUNGRÍA 3/3  La clasificación final de sable masculino individual estuvo compuesta por Aron Szilagyi (HUN, oro), Luca Curatoli (ITA, plata), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR, bronce), Bolade Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) y Matyas Szabo (GER).  La clasificación final de sable masculino por equipos estuvo liderada por Hungría (oro), Francia (plata), Alemania (bronce), Rumanía, Corea, EE. UU., Italia e Irán. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/es/static/_content/38-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 39-title" style="top:75px;left:64px;" src="/120/es/static/_content/39-title-1.png">
        <img class="abs halfScale 39-sub" style="top:220px;left:97px;" src="/120/es/static/_content/39-sub-1.png">
        <img class="abs halfScale 39-line" style="top:223px;left:64px;" src="/120/es/static/_content/39-line-1.png">
        <img id="39-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">
      `,
      "mobileHtml": `
        <h2
          id="a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai">
          Grandes y exitosos Campeonatos del mundo de Esgrima juniors y cadetes de 2022 en Dubái </h2>
        <img src="/120/es/static/_content/39-mobile-1.jpg">
        <p><strong>DUBÁI, Emiratos Árabes Unidos<br>2-10 de abril de 2022</strong></p>
        <p><strong>El Presidente interino de la FIE, Emmanuel Katsiadakis, ha declarado que los Campeonatos del mundo de Esgrima juniors y cadetes de 2022 han sido un gran éxito.</strong></p>
        <p>La prueba del noveno día, que incluyó 18 pruebas individuales y por equipos de esgrimistas masculinos y femeninos juniors y cadetes, contó con el mayor número de participantes de su historia, con 1357 esgrimistas procedentes de 103 países. Las pruebas se celebraron en el impresionante Complejo Deportivo Hamdan de Dubái, un centro deportivo multifuncional de clase mundial conocido por albergar una amplia gama de campeonatos y pruebas internacionales.  </p>
        <p>A continuación, se muestran por continentes los países participantes en los Campeonatos del mundo de Esgrima juniors y cadetes:</p>
        <ul>
          <li>
            África 13</li>
          <li>
            América 20</li>
          <li>
            Asia/Oceanía 32</li>
          <li>
            Europa 38</li>
          <li>
            Total 103 </li>
          </ul>
          <p>La ceremonia oficial de inauguración de los Campeonatos contó con la
            asistencia de varios dignatarios locales, incluido H.E. Dr. Ahmad bin Abdullah
            Humaid Belhoul Al Falasi, Ministro de Estado de iniciativa empresarial y
            PYMEs, además de Presidente de la Junta Directiva de la Autoridad General
            Deportiva; H.E. Sheikh Salem bin Sultan Al Qasimi, miembro del Comité
            Ejecutivo de la FIE, Presidente de la Confederación de Esgrima Asiática,
            Presidente de la Federación de Esgrima Árabe y Presidente de la Federación de
            Esgrima de los EAU; H.E. Saeed Hareb, Secretario General del Consejo de
            Deportes de Dubái y H.E. Nasser Al Rahma, Vicepresidente del Complejo
            Deportivo Hamdan. Los Campeonatos se declararon oficialmente inaugurados por
            el Presidente interino de la FIE Emmanuel Katsiadakis. </p>
          <p>Cada arma (sable, florete y espada) contó con tres días consecutivos de
            competición, y cada ciclo de tres días incluyó un primer día de pruebas
            masculinas y femeninas individuales juniors, seguido de un día de pruebas
            individuales de cadetes y un día final de pruebas juniors por equipos. </p>
          <p>En los Campeonatos se siguieron los protocolos del COVID-19 para garantizar
            la seguridad de todos los participantes y asistentes, incluyendo la
            obligatoriedad de la mascarilla, la distancia social, así como la realización
            de pruebas con frecuencia.
            Las clasificaciones principales incluyeron los siguientes resultados:</p>
          <p>Sable</p>
          <ul>
            <li>
              Sable masculino individual juniors (152 esgrimistas)<ol>
                <li>
                  Colin Heathcock (GER, oro)</li>
                <li>
                  Pietro Torre (ITA, plata)</li>
                <li>
                  Antonio Heathcock (GER, bronce)</li>
                <li>
                  Heegeun Hwang (KOR, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sable femenino individual juniors (126 esgrimistas)<ol>
                <li>
                  Magda Skarbonkiewicz (USA, oro)</li>
                <li>
                  Honor Johnson (USA, plata)</li>
                <li>
                  Zaynab Dayibekova (UZB, bronce)</li>
                <li>
                  Sugar Katinka Battai (HUN, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sable masculino individual cadetes (95 esgrimistas)<ol>
                <li>
                  Zuhridden Kodirov (UZB, oro)</li>
                <li>
                  Colin Heathcock (GER, plata)</li>
                <li>
                  Cody Ji (USA, bronce)</li>
                <li>
                  William Morrill (USA, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sable femenino individual cadetes (90 esgrimistas)<ol>
                <li>
                  Magda Skarbonkiewicz (USA, oro)</li>
                <li>
                  Siobhan Sullivan (USA, plata)</li>
                <li>
                  Alejandra Manga (FRA, bronce)</li>
                <li>
                  Eunyu Kim (KOR, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sable masculino juniors por equipos (34 equipos)<ol>
                <li>
                  Italia (oro)</li>
                <li>
                  Rumanía (plata)</li>
                <li>
                  Egipto (bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Sable femenino juniors por equipos (27 equipos)<ol>
                <li>
                  Francia (oro)</li>
                <li>
                  Hungría (plata)</li>
                <li>
                  Italia (bronce)</li>
              </ol>
            </li>
          </ul>
          <p>Florete</p>
          <ul>
            <li>
              Florete masculino individual juniors (180 esgrimistas)<ol>
                <li>
                  Kazuki Iimura (JPN, oro)</li>
                <li>
                  Hyeonbhin An (KOR, plata)</li>
                <li>
                  Anas Anane (FRA, bronce)</li>
                <li>
                  Chase T. Emmer (USA, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Florete femenino individual juniors (148 esgrimistas)<ol>
                <li>
                  Lauren Scruggs (USA, oro)</li>
                <li>
                  Yuzuha Takeyama (JPN, plata)</li>
                <li>
                  Carolina Stutchbury (GBR, bronce)</li>
                <li>
                  Kateryna Budenko (UKR, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Florete masculino individual cadetes (117 esgrimistas)<ol>
                <li>
                  Tit Nam Cheng (HKG, oro)</li>
                <li>
                  Ruben Lindner (GER, plata)</li>
                <li>
                  Matteo Iacomoni (ITA, bronce)</li>
                <li>
                  Andrew Chen (USA, bronce)</li>
              </ol>
            </li>
            <li>
              Florete femenino individual cadetes (104 esgrimistas)<ol>
                <li>
                  Jessica Zi Jia Guo (CAN, oro)</li>
                <li>
                  Carolina Stutchbury (GBR, plata)</li>
                <li>
                  Rino Nagase (JPN, bronce)</li>
                <li>
                  Matilde Molinari (ITA, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Florete masculino juniors por equipos (37 equipos)<ol>
                <li>
                  Italia (oro)</li>
                <li>
                  Francia (plata)</li>
                <li>
                  Hungría (bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Florete femenino juniors por equipos (32 equipos)<ol>
                <li>
                  USA (oro)</li>
                <li>
                  Italia (plata)</li>
                <li>
                  Japón (bronce)</li>
              </ol>
            </li>
          </ul>
          <p>Espada </p>
          <ul>
            <li>
              Espada masculina individual juniors (208 esgrimistas)<ol>
                <li>
                  Zsombor Keszthelyi (HUN, oro)</li>
                <li>
                  Mohamed Yasseen (EGY, plata)</li>
                <li>
                  James Jeal (GBR, bronce)</li>
                <li>
                  Lino Heurlin Vazquez (FRA, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Espada femenina individual juniors (160 esgrimistas)<ol>
                <li>
                  Hadley Husisian (USA, oro)</li>
                <li>
                  Nicole Feygin (ISR, plata)</li>
                <li>
                  Aleyna Erturk (TUR, bronce)</li>
                <li>
                  Ketki Ketkar (USA, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Espada masculina individual cadetes (142 esgrimistas)<ol>
                <li>
                  Samuel Imrek (USA, oro)</li>
                <li>
                  Alon Sarid (ISR, plata)</li>
                <li>
                  Fabio Mastromarino (ITA, bronce)</li>
                <li>
                  Maksym Perchuk (UKR, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Espada femenina individual cadetes (109 esgrimistas)<ol>
                <li>
                  Aleyna Erturk (TUR, oro)</li>
                <li>
                  Anna Maksymenko (UKR, plata)</li>
                <li>
                  Hailin Chen (HKG, bronce)</li>
                <li>
                  Mizuki Homma (JPN, bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Espada masculina juniors por equipos (42 equipos)<ol>
                <li>
                  Egipto (oro)</li>
                <li>
                  EE. UU. (plata)</li>
                <li>
                  Francia (bronce)</li>
              </ol>
            </li>
          </ul>
          <ul>
            <li>
              Espada femenina juniors por equipos (33 equipos)<ol>
                <li>
                  Israel (oro)</li>
                <li>
                  Polonia (plata)</li>
                <li>
                  EE. UU. (bronce)</li>
              </ol>
            </li>
          </ul>
          <p>Haga clic aquí para ver los MEDALLISTAS [POP UP]</p>
          <p>Tablero completo de medallas</p>
          <ol>
            <li>
              USA - 6 Gold, 3 Silver, 6 Bronze - 15 Total</li>
            <li>
              ITA - 2 Gold, 2 Silver, 4 Bronze - 8 Total</li>
            <li>
              GER - 1 Gold, 2 Silver, 1 Bronze - 4 Total</li>
            <li>
              ISR - 1 Gold, 2 Silver, 0 Bronze - 3 Total</li>
            <li>
              FRA - 1 Gold, 1 Silver, 4 Bronze - 6 Total</li>
            <li>
              JPN - 1 Gold, 1 Silver, 3 Bronze - 5 Total</li>
            <li>
              HUN - 1 Gold, 1 Silver, 2 Bronze - 4 Total</li>
            <li>
              EGY - 1 Gold, 1 Silver, 1 Bronze - 3 Total</li>
            <li>
              TUR - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
            <li>
              HKG - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
            <li>
              UZB - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>
            <li>
              CAN - 1 Gold, 0 Silver, 0 Bronze - 1 Total</li>
            <li>
              UKR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
            <li>
              GBR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
            <li>
              KOR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>
            <li>
              POL - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>
            <li>
              ROU - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>
          </ol>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim
            .fromTo(cOf("39-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("39-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("39-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("39-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg39Anim.stop();
          resetNumbers("39-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DEP ORTE  GRANDES Y EXITOSOS CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DE 2022 EN DUBÁI DUBÁI, EMIRATOS ÁRABES UNIDOS 2-10 DE ABRIL DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="40-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim
            .fromTo(idOf("40-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 2/5  El Presidente interino de la FIE, Emmanuel Katsiadakis, ha declarado que los Campeonatos del mundo de Esgrima juniors y cadetes de 2022 han sido un gran éxito. La prueba del noveno día, que incluyó 18 pruebas individuales y por equipos de esgrimistas masculinos y femeninos juniors y cadetes, contó con el mayor número de participantes de su historia, con 1357 esgrimistas procedentes de 103 países. Las pruebas se celebraron en el impresionante Complejo Deportivo Hamdan de Dubái, un centro deportivo multifuncional de clase mundial conocido por albergar una amplia gama de campeonatos y pruebas internacionales.  A continuación, se muestran por continentes los países participantes en los Campeonatos del mundo de Esgrima juniors y cadetes: África			13 América			20 Asia/Oceanía		 32 Europa			38 Total			103 La ceremonia oficial de inauguración de los Campeonatos contó con la asistencia de varios dignatarios locales, incluido H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministro de Estado de iniciativa empresarial y PYMEs, además de Presidente de la Junta Directiva de la Autoridad General Deportiva; H.E. Sheikh Salem bin Sultan Al Qasimi, miembro"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="41-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim
            .fromTo(idOf("41-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 3/5  del Comité Ejecutivo de la FIE, Presidente de la Confederación de Esgrima Asiática, Presidente de la Federación de Esgrima Árabe y Presidente de la Federación de Esgrima de los EAU; H.E. Saeed Hareb, Secretario General del Consejo de Deportes de Dubái y H.E. Nasser Al Rahma, Vicepresidente del Complejo Deportivo Hamdan. Los Campeonatos se declararon oficialmente inaugurados por el Presidente interino de la FIE Emmanuel Katsiadakis. Cada arma (sable, florete y espada) contó con tres días consecutivos de competición, y cada ciclo de tres días incluyó un primer día de pruebas masculinas y femeninas individuales juniors, seguido de un día de pruebas individuales de cadetes y un día final de pruebas juniors por equipos. En los Campeonatos se siguieron los protocolos del COVID-19 para garantizar la seguridad de todos los participantes y asistentes, incluyendo la obligatoriedad de la mascarilla, la distancia social, así como la realización de pruebas con frecuencia. Las clasificaciones principales incluyeron los siguientes resultados:  SABLE • Sable masculino individual juniors (152 esgrimistas) 1. Colin Heathcock (GER, oro) 2. Pietro Torre (ITA, plata) 3. Antonio Heathcock (GER, bronce) 3. Heegeun Hwang (KOR, bronce) • Sable femenino individual juniors (126 esgrimistas) 1. Magda Skarbonkiewicz (USA, oro) 2. Honor Johnson (USA, plata) 3. Zaynab Dayibekova (UZB, bronce) 3. Sugar Katinka Battai (HUN, bronce) • Sable masculino individual cadetes (95 esgrimistas) 1. Zuhridden Kodirov (UZB, oro) 2. Colin Heathcock (GER, plata) 3. Cody Ji (USA, bronce) 3. William Morrill (USA, bronce)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>

        <img id="42-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim
            .fromTo(idOf("42-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg42Anim.stop();
          resetNumbers("42-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 4/5  FLORETE • Florete masculino individual juniors (180 esgrimistas) 1. Kazuki Iimura (JPN, oro) 2. Hyeonbhin An (KOR, plata) 3. Anas Anane (FRA, bronce) 3. Chase T. Emmer (USA, bronce)  • Sable femenino individual cadetes (90 esgrimistas) 1. Magda Skarbonkiewicz (USA, oro) 2. Siobhan Sullivan (USA, plata) 3. Alejandra Manga (FRA, bronce) 3. Eunyu Kim (KOR, bronce) • Sable masculino juniors por equipos (34 equipos) 1. Italia (oro) 2. Rumanía (plata) 3. Egipto (bronce) • Sable femenino juniors por equipos (27 equipos) 1. Francia (oro) 2. Hungría (plata) 3. Italia (bronce)  • Florete femenino individual juniors (148 esgrimistas) 1. Lauren Scruggs (USA, oro) 2. Yuzuha Takeyama (JPN, plata) 3. Carolina Stutchbury (GBR, bronce) 3. Kateryna Budenko (UKR, bronce) • Florete masculino individual cadetes (117 esgrimistas) 1. Tit Nam Cheng (HKG, oro) 2. Ruben Lindner (GER, plata) 3. Matteo Iacomoni (ITA, bronce) 3. Andrew Chen (USA, bronce) • Florete femenino individual cadetes (104 esgrimistas) 1. Jessica Zi Jia Guo (CAN, oro) 2. Carolina Stutchbury (GBR, plata) 3. Rino Nagase (JPN, bronce) 3. Matilde Molinari (ITA, bronce)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-red.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-red.png">
        </a>
          
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:655px;left:45px" onclick="showOverlay('43-popups')"
          src="/120/es/static/_content/trophy-red.png">
        
        <img id="43-next" class="halfScale pointer" style="top:647px;right:-92px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-red.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="43-popups" class="standardTransition contentOverlay hidden noclick">
          <img src="/120/es/static/_content/39-popup-1.png" style="transform: scale(0.873); transform-origin: top left;">
          <div class="contentLink" style="top: 55px; left: 1025px; width: 35px; height: 35px;" onclick="hideOverlay('43-popups');"></div>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg43Anim = new TimelineMax();
          pg43Anim
            .fromTo(idOf("43-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg43Anim.stop();
          resetNumbers("43-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 5/5  • Florete masculino juniors por equipos (37 equipos) 1. Italia (oro) 2. Francia (plata) 3. Hungría (bronce) • Florete femenino juniors por equipos (32 equipos) 1. USA (oro) 2. Italia (plata) 3. Japón (bronce) ESPADA • Espada masculina individual juniors (208 esgrimistas) 1. Zsombor Keszthelyi (HUN, oro) 2. Mohamed Yasseen (EGY, plata) 3. James Jeal (GBR, bronce) 3. Lino Heurlin Vazquez (FRA, bronce)  Haga clic aquí para ver los MEDALLISTAS  • Espada femenina individual juniors (160 esgrimistas) 1. Hadley Husisian (USA, oro) 2. Nicole Feygin (ISR, plata) 3. Aleyna Erturk (TUR, bronce) 3. Ketki Ketkar (USA, bronce)  • Espada masculina individual cadetes (142 esgrimistas) 1. Samuel Imrek (USA, oro) 2. Alon Sarid (ISR, plata) 3. Fabio Mastromarino (ITA, bronce) 3. Maksym Perchuk (UKR, bronce) • Espada femenina individual cadetes (109 esgrimistas) 1. Aleyna Erturk (TUR, oro) 2. Anna Maksymenko (UKR, plata) 3. Hailin Chen (HKG, bronce) 3. Mizuki Homma (JPN, bronce) • Espada masculina juniors por equipos (42 equipos) 1. Egipto (oro) 2. EE. UU. (plata) 3. Francia (bronce) • Espada femenina juniors por equipos (33 equipos) 1. Israel (oro) 2. Polonia (plata) 3. EE. UU. (bronce) ■ W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 277px; right: 647px; width: 175px; height: 21px;"></div>
        </a>
        <!-- <a href="mailto:service@blue-gauntletservice.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 201px; right: 697px; width: 265px; height: 21px;"></div>
        </a> -->
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 255px; right: 685px; width: 135px; height: 21px;"></div>
        </a>
        <!-- <a href="https://www.blue-gauntlet.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 157px; right: 751px; width: 209px; height: 38px;"></div>
        </a> -->
      `,
      "mobileHtml": `
        <a href="https://www.blue-gauntlet.com" target="_blank">
          <img src="/120/es/static/_content/44-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 45-title" style="top:58px;left:65px;" src="/120/es/static/_content/45-title-1.png">

        <img id="45-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-long-pink.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
        
        <div class="contentLink" onclick="showOverlay('45-popups')" style="bottom: 397px; right: 141px; width: 58px; height: 33px;"></div>

        <div id="45-popups" class="standardTransition contentOverlay hidden noclick">
          <img id="45-pop-1" class="halfScale 45-popup" src="/120/es/static/_content/45-popup-1.png" alt="">
          <img id="45-pop-2" class="halfScale 45-popup" src="/120/es/static/_content/45-popup-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top:721px;left:600px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-1', '45-popup');"></div>
          <div class="contentLink" style="top:721px;left:738px;width:138px;height:48px;"
            onclick="togglePage45('45-pop-2', '45-popup');"></div>
          <div class="contentLink" style="top: 40px; left: 1016px; width: 35px; height: 35px;"
            onclick="hideOverlay('45-popups');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2
          id="bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands">
          Bert M.J. van de Flier (NED, MH) recibió la condecoración real de los Países Bajos
        </h2>
        <img src="/120/es/static/_content/45-mobile-1.jpg">
        <p><strong> Lausana, Suiza<br>6 de diciembre de 2021</strong></p>
        <p><strong>Se ha comunicado a la FIE que el Miembro de Honor de la FIE y Miembro del Consejo de Juego Limpio de la FIE Bert M. J. van de Flier (NED) ha recibido la condecoración «Responsable de la Orden de Orange-Nassau» por parte de su Excelencia Pieter de Gooijer, embajador de los Países Bajos en Francia. El acto se celebró en presencia del Sr. Dominique Breton, cónsul honorario de Brest; el Sr. Guy Pennec, alcalde de Plourin-les-Morlaix; y Leon Pijnappel, presidente de la Federación Neerlandesa de Esgrima (KNAS). </strong></p>
        <p>La condecoración supera el título de caballero, uno de los premios más importantes que se le puede conceder a un civil de los Países Bajos, y que se le otorga en reconocimiento a sus numerosos años de servicio y dedicación a la esgrima neerlandesa, europea y mundial. A lo largo de muchos años, el Sr. van de Flier ha desempeñado muchas funciones y ha obtenido numerosos logros que han conducido a este premio:</p>
        <p>El Sr. van de Flier fue nombrado Miembro de Honor de la FIE en el Congreso de París de 2013 e incluido en el Salón de la Fama de la FIE en 2014. Fue miembro de la Comisión encargada del Baremo de Votos de la FIE, del Comité disciplinario y presidió el Consejo de Juego Limpio de la FIE. Ha sido presidente de DT en los Campeonatos del Mundo y supervisor habitual oficial de la Copa del mundo de la FIE.</p>
        <p>Desde 2012, el Sr. van de Flier ha trabajado en el Comité Internacional de Juego Limpio (CIFP) y ha sido su secretario tesorero desde 2015. Su trabajo permitió la creación del Consejo de Juego Limpio de la FIE en 2017.</p>
        <p>El Sr. van de Flier ha sido Miembro de Honor de la KNAS desde 1995 y participó activamente en la organización desde 1978. Presidió su Comisión Técnica antes de  convertirse en secretario general de la KNAS en 1981 y en presidente provisional en 1982. Se convirtió así en el presidente más joven de la KNAS, función que desempeñó durante 12 años. Después de abandonar el consejo en 1995, volvió a unirse como secretario general en 2010, un cargo que todavía conserva. </p>
        <p>Ayudó a fundar la Confederación Europea de Esgrima en 1991 y formó parte de su consejo durante 17 años, siendo secretario general, primer vicepresidente, tesorero y presidente de la Comisión SEMI. Se han organizado varios campeonatos del mundo y europeos en los Países Bajos desde 1985 hasta 1995 gracias a los esfuerzos del Sr. van de Flier, también reconocido por su labor fundamental a la hora de promover que las competiciones Airborne Trophy y Zoetermeer Trophy se conviertan en (antiguas) Copas del mundo de la FIE en los Países Bajos.</p>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim
            .fromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("45-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage45(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg45Anim.stop();
          resetNumbers("45-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NOTICIAS DE L A FIE  NOTICIAS DE LA FIE Bert M.J. van de Flier (NED, MH) recibió la condecoración real de los Países Bajos Ver más aquí  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
        <a href="https://www.fencewithfun.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 259px; right: 22px; width: 33px; height: 154px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="https://www.fencewithfun.com" target="_blank">
          <img src="/120/es/static/_content/pg46.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 47-title" style="top:160px;left:65px;" src="/120/es/static/_content/47-title-1.png">
        <img class="abs halfScale 47-sub" style="top:388px;left:92px;" src="/120/es/static/_content/47-sub-1.png">
        <img class="abs halfScale 47-line" style="top:390px;left:64px;" src="/120/es/static/_content/47-line-1.png">
        <img id="47-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-green.png">
      `,
      "mobileHtml": `
        <h2 id="togo-hosts-fencing-equipment-repair-course">Togo acoge el Curso de reparación de equipamiento de esgrima</h2>
        <img src="/120/es/static/_content/47-mobile-1.jpg">
        <p><strong>Lomé, Togo <br>14 de enero de 2022</strong></p>
        <p><strong>La Federación de Esgrima de Togo acogió un curso de reparación de equipamiento de esgrima desde el 14 al 18 de diciembre de 2021, que albergó 14 participantes de cuatro ligas de esgrima de la región. </strong></p>
        <p>El curso, celebrado a petición del Presidente de la Federación Victor Laméga, fue financiado por la FIE, que proporcionó formación especializada, equipamiento y herramientas. </p>
        <p>El Sr. Gilles Martinage (FRA), que ha trabajado como armero oficial y ha gestionado el control de armas en numerosas pruebas a nivel mundial, se encargó de la preparación y de la formación durante el curso. </p>
        <p>Los 14 participantes contaban con diferentes niveles de experiencia, incluidos los atletas, los entrenadores, maestros de esgrima en Dakar o Argel, atletas que se estaban formando para ser entrenadores y el árbitro internacional y director técnico de la Federación de Togo, el Sr. Koffi Kassefon. </p>
        <p>Se proporcionó contenido teórico e informativo sobre los sistemas eléctricos de puntuación, los aspectos técnicos del manejo de armas y los reglamentos actuales de los equipos. Los temas del curso englobaron la detección de anomalías, la reparación y el montaje completo de las armas, la comprobación de las instalaciones de la pista y la supervisión adecuada del equipo personal (por ejemplo, hojas, cables que van al cuerpo, caretas, etc.). </p>
        <p>El curso en general fue interactivo y práctico, y estuvo centrado en desarrollar y practicar las habilidades técnicas. El contenido diario abordó los intereses, las habilidades y las expectativas personales de los participantes, y se centró en garantizar que dichos participantes desarrollaran la capacidad de reproducir de manera consistente las técnicas aprendidas. Para realizar los ejercicios prácticos se utilizó el equipamiento proporcionado por la FIE: 12 kits básicos de reparación, tres maletines de armas y un kit especial para reparar bobinas de cable. El objetivo de estos ejercicios se basaba en la eficacia a la hora de rehabilitar las armas de competición, estandarizar los cables que van al cuerpo, reparar bobinas, colocar los cables de la pista y reparar el aparato de puntuación. Los participantes aprendieron a examinar todo el equipamiento, a comprobar y detectar la existencia de anomalías, a determinar la realización de reparaciones adecuadas y necesarias y a llevar a cabo las reparaciones, como soldar, unir cables a hojas y restaurar hilos conductores metálicos para garantizar una buena conductividad. </p>
        <p>Gracias al curso, los participantes aprendieron a evaluar y reparar de manera efectiva prácticamente todas las armas de competición de la FIE, así como a probar y reparar los cables que van al cuerpo, a reparar los controles remotos de los sistemas de puntuación y a fabricar cables diseñados para conectar bobinas de cable a las armas. </p>
        <p>Cuando se entregaron los certificados de participación a los aprendices, el Sr. Martinage destacó el entusiasmo de los participantes, así como su excelente trabajo y su meticulosidad a lo largo del curso. El Presidente de la Federación de Togo, Laméga también elogió el «espíritu de cohesión» que había prevalecido durante el programa.</p>
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim
            .fromTo(cOf("47-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("47-line"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("47-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(idOf("47-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        
        function onPageLeave() {
          pg47Anim.stop();
          resetNumbers("47-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NOTICIAS DE C ONFEDER ACIÓN Y FEDER ACIÓN  TOGO ACOGE EL CURSO DE REPARACIÓN DE EQUIPAMIENTO DE ESGRIMA LOMÉ, TOGO 14 DE ENERO DE 2022"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-green.png">
        </a>

        <img id="48-next" class="halfScale pointer" style="top:647px;right:-95px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-edge-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim
            .fromTo(idOf("48-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg48Anim.stop();
          resetNumbers("48-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN 2/3  La Federación de Esgrima de Togo acogió un curso de reparación de equipamiento de esgrima desde el 14 al 18 de diciembre de 2021, que albergó 14 participantes de cuatro ligas de esgrima de la región. El curso, celebrado a petición del Presidente de la Federación Victor Laméga, fue financiado por la FIE, que proporcionó formación especializada, equipamiento y herramientas. El Sr. Gilles Martinage (FRA), que ha trabajado como armero oficial y ha gestionado el control de armas en numerosas pruebas a nivel mundial, se encargó de la preparación y de la formación durante el curso.  Los 14 participantes contaban con diferentes niveles de experiencia, incluidos los atletas, los entrenadores, maestros de esgrima en Dakar o Argel, atletas que se estaban formando para ser entrenadores y el árbitro internacional y director técnico de la Federación de Togo, el Sr. Koffi Kassefon. Se proporcionó contenido teórico e informativo sobre los sistemas eléctricos de puntuación, los aspectos técnicos del manejo de armas y los reglamentos actuales de los equipos. Los temas del curso englobaron la detección de anomalías, la reparación y el montaje completo de las armas, la comprobación de las instalaciones de la pista y la supervisión adecuada del equipo personal (por ejemplo, hojas, cables que van al cuerpo, caretas, etc.). El curso en general fue interactivo y práctico, y estuvo centrado en desarrollar y practicar las habilidades técnicas. El contenido diario abordó los intereses, las habilidades y las expectativas personales de los participantes, y se centró en garantizar que dichos participantes"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:41px"
            src="/120/es/static/_content/tw-green.png">
        </a>
        
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:323px;left:94px"
            src="/120/es/static/_content/fb-green.png">
        </a>

        <img id="49-next" class="halfScale pointer" style="top:647px;right:-79px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-pad-green.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim
            .fromTo(idOf("49-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "la existencia de anomalías, a determinar la realización de reparaciones adecuadas y necesarias y a llevar a cabo las reparaciones, como soldar, unir cables a hojas y restaurar hilos conductores metálicos para garantizar una buena conductividad.  NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN 3/3  desarrollaran la capacidad de reproducir de manera consistente las técnicas aprendidas. Para realizar los ejercicios prácticos se utilizó el equipamiento proporcionado por la FIE: 12 kits básicos de reparación, tres maletines de armas y un kit especial para reparar bobinas de cable. El objetivo de estos ejercicios se basaba en la eficacia a la hora de rehabilitar las armas de competición, estandarizar los cables que van al cuerpo, reparar bobinas, colocar los cables de la pista y reparar el aparato de puntuación. Los participantes aprendieron a examinar todo el equipamiento, a comprobar y detectar  Gracias al curso, los participantes aprendieron a evaluar y reparar de manera efectiva prácticamente todas las armas de competición de la FIE, así como a probar y reparar los cables que van al cuerpo, a reparar los controles remotos de los sistemas de puntuación y a fabricar cables diseñados para conectar bobinas de cable a las armas. Cuando se entregaron los certificados de participación a los aprendices, el Sr. Martinage destacó el entusiasmo de los participantes, así como su excelente trabajo y su meticulosidad a lo largo del curso. El Presidente de la Federación de Togo, Laméga también elogió el «espíritu de cohesión» que había prevalecido durante el programa. ■  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": ``,
      "mobileHtml": `
        <img src="/120/es/static/_content/50-mobile-1.jpg">
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 51-title" style="top:120px;left:66px;" src="/120/es/static/_content/51-title-1.png">

        <img id="51-next" class="halfScale pointer" style="top:718px;right:-243px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-long-orange.png">

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div class="contentLink" onclick="showOverlay('51-popups-1')" style="bottom: 250px; right: 912px; width: 82px; height: 27px;"></div>
        <div class="contentLink" onclick="showOverlay('51-popups-2')" style="bottom: 483px; right: 321px; width: 64px; height: 23px;"></div>

        <div id="51-popups-1" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2" src="/120/es/static/_content/51-popup-1-1.png" alt="">
          <div class="contentLink" style="top: 56px; left: 1009px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-1');"></div>  
        </div>
        <div id="51-popups-2" class="standardTransition contentOverlay hidden noclick">
          <img id="51-pop-2-1" class="halfScale 51-popup-2A" src="/120/es/static/_content/51-popup-2-1.png" alt="">
          <img id="51-pop-2-2" class="halfScale 51-popup-2" src="/120/es/static/_content/51-popup-2-2.png" style="opacity:0" alt="">
          <div class="contentLink" style="top: 798px; left: 600px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-1', '51-popup-2');"></div>
          <div class="contentLink" style="top: 798px; left: 755px; width: 125px; height: 48px;"
            onclick="togglePage51('51-pop-2-2', '51-popup-2');"></div>
          <div class="contentLink" style="top: 55px; left: 1009px; width: 35px; height: 35px;"
            onclick="hideOverlay('51-popups-2');"></div>
        </div>
      `,
      "mobileHtml": `
        <h2 id="fie-news">NOTICIAS DEL MUNDO</h2>
        <p><strong>1<br>Celebrados los talleres Athlete365 Career+ en los Campeonatos
            del mundo de esgrima juniors y cadetes de 2022 en Dubái</strong></p>
        <img src="/120/es/static/_content/51-mobile-1.jpg">
        <p><strong>Antes del inicio de los Campeonatos del mundo de esgrima juniors y
            cadetes de 2022 en Dubái (Emiratos Árabes Unidos), se celebró un taller
            Athlete365 Career+ «Power-Up» del COI para esgrimistas que estaban
            participando en un curso oficial de entrenamiento de la FIE.</strong></p>
        <p>TEl taller fue dirigido por Maria Ntanou, tres veces atleta olímpica y
          gerente de comunicación digital de la FIE, y en él participaron 16 esgrimistas
          de 16 países. </p>
        <p>El taller duró medio día y abarcó diferentes módulos como, por ejemplo, cómo
          identificar los puntos fuertes y los valores. </p>
        <p>El taller enseña que no importa en qué etapa de su carrera se encuentre, ya
          que es importante tomarse tiempo para reflexionar y evaluar quiénes somos y
          qué deseamos conseguir en la vida. Saber cuáles son sus auténticas facultades
          y lo que realmente le motiva y le impulsa le ayudará en todos los aspectos de
          su carrera y de su vida.</p>
        <p>La primera sesión se centró en la autorreflexión y en actividades entre
          grupos de atletas, que respondieron a preguntas como: «¿En qué destaco?», «¿En
          qué podría ser mejor?» y «¿Qué es importante para mí?»</p>
        <p>Al final de la sesión, los esgrimistas pudieron identificar tres puntos
          fuertes principales de su personalidad y tres facultades que podrían
          desarrollar aún más. </p>
        <p><strong>2<br>Celebrados los talleres Athlete365 Career+ en los Campeonatos
            del mundo de esgrima juniors y cadetes de 2022 en Dubái</strong></p>
        <img src="/120/es/static/_content/51-mobile-2.jpg">
        <p><strong>Hoy es el Día Internacional del Deporte para el Desarrollo y la Paz
            (IDSDP, por sus siglas en inglés), designado por la Asamblea General de las
            Naciones Unidas, un movimiento que cuenta con el apoyo de la FIE.</strong>
        </p>
        <p>Cada año, el 6 de abril, el mundo del deporte destaca el poder único del
          deporte en el apoyo a las personas y las comunidades para superar la
          adversidad y contribuir de manera significativa como un facilitador
          fundamental del desarrollo sostenible. Reconoce las actividades deportivas y
          su influencia positiva hacia la paz y la armonía en la convivencia de las
          comunidades de todo el mundo. </p>
        <p>En los Campeonatos del Mundo de Esgrima Juveniles y Cadetes, que se celebran
          del 2 al 10 de abril en Dubai (Emiratos Árabes Unidos), se informó a los
          atletas sobre el IDSDP y, como es el símbolo distintivo de la organización, se
          les pidió que sostuvieran tarjetas blancas. Son una referencia a las tarjetas
          amarillas y rojas de penalización en el mundo del deporte, y desde 2014 una
          #WhiteCard es el símbolo que creó la organización «Peace and Sport», para
          representar el poder positivo del deporte por la paz y la inclusión social.
        </p>
        <p>Los atletas adolescentes internacionales que participan en los Campeonatos
          del Mundo de Esgrima Juveniles y Cadetes de las tres armas de esgrima (espada,
          florete y sable) y de ambos sexos aportaron sus opiniones sobre la iniciativa
          del 6 de abril:</p>
        <p>«El deporte es una forma de vincularse con algo que todos tenemos en común.
          Aquí hay miles de esgrimistas que dejan de lado sus diferencias para competir.
          Por supuesto, no podemos hacerlo sin la paz».</p>
        <p>Jakob Lars Kristmannson (ISL)</p>
        <p>«La paz y el deporte unen a las personas aunque haya competencia. Hay un
          nivel de deportividad y comprensión, así que es una gran manera de unir a la
          gente».
          Sanojah Gilkes (BAR)</p>
        <p>«Los deportes como la esgrima unen a las personas; quieren competir pero
          también quieren mostrar compañerismo. Como deportista, aunque se luche, se
          quiere estar seguro de ser pacífico cuando no se compite para acercarse y
          retroalimentarse de manera mutua».
          Daniella Weng Yan Tang (SGP)</p>
        <p>Según la organización Peace and Sport, «a través de una #WhiteCard, cada uno
          de nosotros puede defender el poder único del deporte para el desarrollo
          social y la paz y compartir una historia sobre cómo el deporte nos ayudó a
          superar los desafíos».</p>
      `,
      "script": `
        function onPageEnter() {
          pg51Anim = new TimelineMax();
          pg51Anim
            .fromTo(cOf("51-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("51-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, "-=0.2")
        }
        function togglePage51(show, hide) {
          var show = idOf(show)
          var hide = cOf(hide)
          TweenMax.to(hide, 0.01, {opacity: 0});
          TweenMax.to(show, 0.01, {opacity:1});
        }
        function onPageLeave() {
          pg51Anim.stop();
          resetNumbers("51-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NOTICIAS DEL MUNDO  NOTICIAS DEL MUNDO 2  WWW.FIE.ORG  La FIE apoya el 6 de abril el Día Internacional del Deporte para el Desarrollo y la Paz Haga clic aquí para leer el artículo completo  1  Talleres Athlete365 Career+ en Dubái Haga clic aquí para leer el artículo completo  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
        <a href="mailto:jason@jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 76px; right: 352px; width: 235px; height: 19px;"></div>
        </a>
        <a href="http://www.jiangfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 97px; right: 377px; width: 211px; height: 17px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.jiangfencing.com" target="_blank">
          <img src="/120/es/static/_content/52-mobile-1.jpg">
        </a>
      `,      
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 53-title" style="top:41px;left:61px;" src="/120/es/static/_content/53-title-1.png">

        <img id="53-next" class="halfScale pointer" style="top:719px;right:-184px" onclick="Publish.goToNextPage()"
          src="/120/es/static/_content/arrow-long-navy.png">
        
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom: 8px; right: 58px; width: 90px; height: 17px;"></div>
        </a>

        <div id="53-1" class="abs noOverflow 53-div" style="top:299px; left: 65px; height: 520px; width: 810px; display: block;">
          <img id="53-text-1a" class="halfScale 53-text-1" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-1-1.png">
          <img id="53-text-1b" class="halfScale 53-text-1" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-1-2.png">
          <div id="53-btn-1a" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')"></div>
          <div id="53-btn-1b" class="abs halfScale pointer 53-btn-1"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')"></div>
        </div>
        
        <div id="53-2" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-2a" class="halfScale 53-text-2" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-2-1.png">
          <img id="53-text-2b" class="halfScale 53-text-2" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-2-2.png">
          <div id="53-btn-2a" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')"></div>
          <div id="53-btn-2b" class="abs halfScale pointer 53-btn-2"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')"></div>
        </div>
        
        <div id="53-3" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-3a" class="halfScale 53-text-3" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-3-1.png">
          <img id="53-text-3b" class="halfScale 53-text-3" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-3-2.png">
          <div id="53-btn-3a" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')"></div>
          <div id="53-btn-3b" class="abs halfScale pointer 53-btn-3"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')"></div>
        </div>
        
        <div id="53-4" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-4a" class="halfScale 53-text-4" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-4-1.png">
          <img id="53-text-4b" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-4-2.png">
          <img id="53-text-4c" class="halfScale 53-text-4" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-4-3.png">
          <div id="53-btn-4a" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')"></div>
          <div id="53-btn-4b" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')"></div>
          <div id="53-btn-4c" class="abs halfScale pointer 53-btn-4"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')"></div>
        </div>
        
        <div id="53-5" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-5a" class="halfScale 53-text-5" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-5-1.png">
          <img id="53-text-5b" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/es/static/_content/53-text-5-2.png">
          <img id="53-text-5c" class="halfScale 53-text-5" style="top:0px;left:0px; opacity:0;;"
            src="/120/es/static/_content/53-text-5-3.png">
          <div id="53-btn-5a" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')"></div>
          <div id="53-btn-5b" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')"></div>
          <div id="53-btn-5c" class="abs halfScale pointer 53-btn-5"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')"></div>
        </div>
        
        <div id="53-6" class="abs noOverflow 53-div" style="top:299px;left:65px;height:700px;width:880px;display:none">
          <img id="53-text-6a" class="halfScale 53-text-6" style="top:0px;left:0px;"
            src="/120/es/static/_content/53-text-6-1.png">
          <img id="53-text-6b" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-6-2.png">
          <img id="53-text-6c" class="halfScale 53-text-6" style="top:0px;left:0px; opacity:0;"
            src="/120/es/static/_content/53-text-6-3.png">
          <div id="53-btn-6a" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 397px; width: 251px; height: 96px;"
            onclick="togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')"></div>
          <div id="53-btn-6b" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')"></div>
          <div id="53-btn-6c" class="abs halfScale pointer 53-btn-6"
            style="top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;"
            onclick="togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')"></div>
        </div>
        
        <img id="53-cta-1" class="halfScale pointer 53-btn" style="top:258px;left:869px;transform:scale(0.506,0.52);"
          onclick="pg53Toggle('53-1', '53-cta-1');" src="/120/es/static/_content/53-name-1.png">
        <img id="53-cta-2" class="halfScale pointer 53-btn" style="top:325px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-2', '53-cta-2');" src="/120/es/static/_content/53-name-2.png">
        <img id="53-cta-3" class="halfScale pointer 53-btn" style="top:393px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-3', '53-cta-3');" src="/120/es/static/_content/53-name-3.png">
        <img id="53-cta-4" class="halfScale pointer 53-btn" style="top:461px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-4', '53-cta-4');" src="/120/es/static/_content/53-name-4.png">
        <img id="53-cta-5" class="halfScale pointer 53-btn" style="top:528px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-5', '53-cta-5');" src="/120/es/static/_content/53-name-5.png">
        <img id="53-cta-6" class="halfScale pointer 53-btn" style="top:595px;left:869px;transform:scale(0.506,0.52);opacity:0"
          onclick="pg53Toggle('53-6', '53-cta-6');" src="/120/es/static/_content/53-name-6.png">
      `,
      "mobileHtml": `
        <h2 id="obituaries">NECROLÓGICAS</h2>
        <p><strong>1<br>Jahangir Safarov (AZE)</strong></p>
        <img src="/120/es/static/_content/53-mobile-1.png">
        <p><strong>La FIE lamenta el fallecimiento de Jahangir Safarov (AZE) el 12 de noviembre.</strong></p>
        <p>Fue entrenador del equipo nacional de esgrima de Azerbaiyán y árbitro nacional. Nació el 9 de marzo de 1968. </p>
        <p>Safarov comenzó a practicar la esgrima a los 10 años. Llegó a ser medallista en numerosas competencias de la URSS y participó en Campeonatos del Mundo y de Europa, y fue nombrado Maestro del Deporte de la URSS en 1985.</p>
        <p>En 2001, se convirtió en el entrenador del equipo nacional de Azerbaiyán, del que salieron varios campeones nacionales y medallistas en pruebas internacionales y regionales, y fue el entrenador principal de sable femenino cadetes. La alumna de Safarov, Zarifa Huseynova, ganó la medalla de bronce en sable femenino cadetes individual en los Campeonatos del Mundo de Esgrima Juveniles y Cadetes de El Cairo en 2021. Su hijo, Javanshir Safarov, al que también entrenó, obtuvo la plata en sable masculino en la Copa del Mundo Juvenil de Teherán en diciembre de 2013. </p>
        <p>En nombre de la familia mundial de la esgrima, la FIE ofrece sus más sinceras condolencias a la familia y los amigos de Jahangir Safarov, a la Federación de Esgrima de Azerbaiyán y a la Confederación Europea de Esgrima, y expresamos nuestro más profundo pésame en estos momentos tan difíciles.</p>
        <p><strong>2<br>Alex Orban (EE. UU.)</strong></p>
        <img src="/120/es/static/_content/53-mobile-2.png">
        <p><strong>La FIE lamenta el fallecimiento de Alex Orban (EE. UU.) el 2 de diciembre a la edad de 82 años, compitió tres veces en los Juegos Olímpicos como esgrimista de sable.</strong></p>
        <p>Nació el 25 de agosto de 1939 en Budapest (Hungría) y comenzó a practicar la esgrima a los 14 años. A los 16 años era el esgrimista más joven que había logrado una clasificación de primera clase en Hungría y se le calificó como la «próxima estrella del equipo magiar». </p>
        <p>El Sr. Orban se trasladó a EE. UU. y, después de prestar tres años de servicio militar, entrenó y compitió en esgrima. Formó parte del equipo olímpico de esgrima de EE. UU. en los Juegos Olímpicos de 1968 (Ciudad de México), 1972 (Múnich) y 1976 (Montreal). </p>
        <p>Fue campeón nacional de sable de EE. UU. en 1965 y todos los años de 1969 a 1972, así como campeón de sable individual en los Juegos Panamericanos de 1971 en Cali, Colombia. También ganó la medalla de plata en sable masculino por equipos en los Juegos Panamericanos de 1971 y 1975 (Ciudad de México). Fue el primer esgrimista de sable estadounidense en ganar una prueba internacional de categoría «A» en 1968 en Lodz (Polonia).</p>
        <p>El Sr. Orban fue incluido en el Salón de la Fama de la Esgrima de EE. UU. en 1999. En nombre de la familia mundial de esgrima, la FIE ofrece sus más sinceras condolencias a la familia y amigos de Alex Orban, al equipo de Esgrima de EE. UU. y a la Confederación Panamericana de Esgrima, y les expresamos nuestro más sentido pésame en estos momentos tan difíciles.
        </p>
        <p><strong>3<br>Ali Youssef Hussain (KUW, MH)</strong></p>
        <img src="/120/es/static/_content/53-mobile-3.png">
        <p><strong>La FIE lamenta el fallecimiento, el 26 de diciembre, de Ali Youssef Hussain (KUW), Miembro de honor de la FIE y miembro del Salón de la Fama. Nació en 1938.</strong></p>
        <p>Ex miembro del Comité Ejecutivo de la FIE (2001-2008), el Congreso lo nombró Miembro de honor en 2008. De 1985 a 2004, fue miembro de la Comisión de Propaganda de la FIE (ahora denominada Comisión de Promoción, Comunicación y Marketing). </p>
        <p>En 1977, fue elegido miembro de la Asociación de Esgrima Amateur de Kuwait, ejerciendo a lo largo del tiempo como su presidente durante ocho años, así como miembro de la Junta Directiva y del Comité Técnico, y gestor de productos de la organización. El Sr. Hussain fue miembro de la Junta Directiva del Comité Olímpico Nacional de Kuwait, y fue su secretario-tesorero desde 1994 hasta 2014. </p>
        <p>Desde muy joven participó en varios deportes, y durante muchos años fue miembro del Club Deportivo Yarmouk, desde 1965, año de su fundación. Formó parte de su junta directiva durante 10 años y fue su secretario general y presidente.</p>
        <p>Entre varios programas educativos, el Sr. Hussain asistió a un curso olímpico internacional de gestión deportiva en 1987. También estudió gestión y ciencias del deporte con la supervisión de la Federación Deportiva Árabe, lo que le permitió, a partir de 1988, seguir su carrera en la administración deportiva. </p>
        <p>La FIE ofrece sus sinceras condolencias y expresa su más profundo pésame a la familia y amigos de Ali Youssef Hussain, a la Asociación de Esgrima Amateur de Kuwait y a la Confederación Asiática de Esgrima.</p>
        <p><strong>4<br>Olga Orban-Szabov (ROM)</strong></p>
        <img src="/120/es/static/_content/53-mobile-4.png">
        <p><strong>La FIE está entristecida por la noticia del fallecimiento, que tuvo lugar el día 5 de enero, de Olga Orban-Szabo (ROM), quien fue medallista olímpica en numerosas ocasiones, campeona del mundo y miembro del Salón de la Fama de la FIE. </strong></p>
        <p>Nacida el 9 de octubre de 1938 en Cluj, la Sra. Szabo fue la primera medallista olímpica y campeona del mundo de Rumanía, y compitió en cinco Juegos Olímpicos (Melbourne 1956, Roma 1960, Tokio 1964, Ciudad de México 1968 y Múnich 1972). Ganó su primera medalla olímpica, una plata en florete femenino individual, en Melbourne, y posteriormente una medalla de bronce en florete femenino por equipos, en los Juegos de Ciudad de México y de Múnich. 
        </p>
        <p>Se convirtió en campeona mundial de florete femenino individual en los Campeonatos del Mundo de Buenos Aires de 1962. Como parte del equipo rumano de florete femenino (en el que se incluyen Maria Vicol, Ileana Gyulai, Ecaterina Stahl y Ana Pascu), obtuvo una medalla de oro en los Campeonatos del Mundo de la Havana de 1969, otra primera medalla para su país. 
        </p>
        <p>En definitiva, la Sra. Orban-Szabo ganó 11 medallas olímpicas y de Campeonatos del Mundo en florete femenino, incluidas tres medallas de los Juegos Olímpicos y ocho de los Campeonatos del Mundo entre 1961 y 1970. Anteriormente, fue medallista de plata juvenil a nivel mundial en 1959.</p>
        <p>También ganó tres medallas en las Universiadas, incluida la plata individual y el oro por equipos en 1961 y la plata por equipos en 1965.  </p>
        <p>Como miembro del club de armas «Steaua Bucarest», ganó siete veces el campeonato nacional de Rumanía, y obtuvo el título nacional de «Emeritus Master of Sport», así como numerosas órdenes y títulos rumanos. Se graduó en la Universidad de Babes-Bolyai en Cluj-Napoca y también fue maestra de esgrima. Tras su retirada de la competición en 1972, trabajó como entrenadora de esgrima juvenil en su club de Bucarest.</p>
        <p>«Fue una dama distinguida del equipo de esgrima rumano», afirmó Marius Florea, Presidente de la Federación de Rumanía. «La Federación de Esgrima de Rumanía desea expresar su profunda gratitud a la Sra. Olga Orban-Szabo por su contribución a la fundación de la familia rumana de esgrima». </p>
        <p>La FIE presenta sus más sinceras condolencias y su profundo pésame a la familia y a los amigos de Olga Orban-Szabo, así como a la Federación de Esgrima de Rumanía y a la Confederación Europea de Esgrima.</p>
        <p><strong>5<br>Jose Valarinho (POR)</strong></p>
        <img src="/120/es/static/_content/53-mobile-5.png">
        <p><strong>La FIE está entristecida por la noticia del fallecimiento de Jose Valarinho (POR) el día 30 de marzo de 2022 a los 87 años de edad. Jose Valarinho fue miembro del Salón de la Fama de la FIE. Asimismo, fue miembro de la Comisión Disciplinaria de la FIE desde 1996 hasta 2004.</strong></p>
        <p>Fue galardonado con una medalla de oro especial de la FIE en tres ocasiones por su trabajo académico sobre la esgrima, así como por organizar el Congreso de la FIE de 1988 en Madeira y los Campeonatos del mundo de Lisboa de 2002. También recibió la Orden Olímpica del Comité Olímpico Portugués y la Medalla al Mérito Deportivo por parte del gobierno portugués. </p>
        <p>El Sr. Valarinho fue presidente de la Federación Portuguesa de Esgrima durante dos mandatos a partir de 1992. Se unió a la organización en 1969 como presidente de la Comisión Técnica y durante varias décadas ejerció una gran influencia sobre el crecimiento y el desarrollo de la esgrima en Portugal. Participó en un «Plan para el Desarrollo del Deporte» con un programa especial, «500 Floretes», y trabajó para ayudar a Portugal a desempeñar un papel más activo en la esgrima internacional. </p>
        <p>El Sr. Valarinho participó en la organización del primer Campeonato de Europa en Lisboa, en 1983, así como en numerosas competiciones continentales y mundiales celebradas en Portugal durante las décadas de 1980 y 1990. Su idea de que los portugueses se convirtieran en participantes de peso en la esgrima mundial se hizo realidad cuando el equipo de florete masculino de su país ganó la medalla de oro en el Campeonato de Europa de 2000 celebrado en Madeira. Tras dejar la presidencia, organizó con éxito los Campeonatos del mundo de Esgrima de Lisboa de 2002. </p>
        <p>Con educación militar tradicional portuguesa, el Sr. Valarinho finalmente se convirtió en oficial del ejército, y fue durante su educación cuando tuvo el primer contacto con la esgrima y se convirtió en un experto ecuestre. Se graduó con honores como maître en el Centro Deportivo Militar de Mafra, donde fue un esgrimista competitivo y participó en la Universiada de 1959 como miembro del equipo de sable masculino. Después de la escuela, se convirtió en maestro de esgrima, especializado en la selección y el desarrollo de jóvenes esgrimistas.</p>
        <p>Fue autor de dos libros sobre historia de la esgrima portuguesa y estaba preparando una tercera edición. </p>
        <p>«Fue esgrimista hasta el día de su muerte», afirmó su hijo Frederico Valarinho, miembro de la Federación Portuguesa de Esgrima desde 2006.</p>
        <p>La FIE presenta sus más sinceras condolencias a la familia y a los amigos de Jose Valarinho, así como a la Federación Portuguesa de Esgrima y a la Confederación Europea de Esgrima. Les expresamos nuestro más profundo pésame en estos difíciles momentos.</p>
        <p> <strong>6<br>Ana Pascu (ROU, MH)</strong></p>
        <img src="/120/es/static/_content/53-mobile-6.png">
        <p><strong>La FIE lamenta profundamente el fallecimiento en Bucarest, el 6 de abril de 2022, de la Sra. Ana Pascu (ROU), Miembro de Honor de la FIE y miembro del Salón de la Fama. Nació el 22 de septiembre de 1944.</strong> </p>
        <p>Elegida en el año 2000, la Sra. Pascu ha sido miembro del Comité Ejecutivo de la FIE, y ha sido vicepresidenta de 2004 a 2021. Anteriormente, fue miembro de la Comisión del Reglamento de la FIE de 1984 a 1988 y de la Comisión de Arbitraje de la FIE de 1988 a 1996. También fue árbitro internacional de la FIE en florete y espada. </p>
        <p>Tiene el récord de ser la presidenta más longeva de la Federación Rumana de Esgrima. De 1982 a 2013, la Sra. Pascu dirigió la Federación, contribuyendo a los logros deportivos de los esgrimistas rumanos, que ganaron 134 medallas durante su mandato, incluidas nueve en los Juegos Olímpicos, 57 en los Campeonatos del Mundo y 68 en los Campeonatos de Europa. Tras su retirada como presidenta, fue nombrada presidenta de honor de la Federación Rumana de Esgrima. También fue vicepresidenta del Comité Olímpico y Deportivo Rumano. </p>
        <p>Como atleta, Pascu fue cinco veces floretista olímpica, y en florete por equipos ganó una medalla de bronce en los Juegos Olímpicos de 1968 y 1972 y la medalla de oro en los Campeonatos del Mundo de La Habana en 1969. En florete individual, ganó el Campeonato del Mundo junior en 1963, así como la medalla de bronce en el Campeonato del Mundo de 1971. Como parte del equipo rumano de florete femenino, ganó la medalla de plata en florete por equipos en los Campeonatos del Mundo de 1970 y las medallas de bronce en los Campeonatos del Mundo de 1961, 1967, 1971, 1973, 1974 y 1975. En 1961 y 1965, su equipo ganó el oro y la plata, respectivamente, en los Juegos Mundiales Universitarios («Universiadas»). </p>
        <p>La Sra. Pascu también hizo carrera como entrenadora de esgrima y profesora de educación física hasta 1982, habiendo obtenido un doctorado en educación física y deporte. Su tesis doctoral se tituló La estrategia para mejorar la preparación deportiva en las competencias. También es «Doctora Honoris Causa» por la Universidad Vasile Goldis de Rumanía. Fue autora de numerosas publicaciones científicas y deportivas y recibió varios títulos y condecoraciones, como la Orden Nacional del Mérito en grado de Oficial y Caballero.   La Sra. Pascu dedicó toda su vida a la esgrima, a los esgrimistas, a la esgrima rumana y a la FIE, y los numerosos éxitos resultantes son testimonio de su increíble talento y pasión por nuestro deporte. En palabras de Emmanuel Katsiadakis, Presidente interino de la FIE, «Ella ayudó, apoyó y motivó incansablemente y con infinita amabilidad a todos los que buscaron su ayuda y consejo. Fue una destacada mentora y modelo de conducta para los atletas, funcionarios y dirigentes de la esgrima, así como para las niñas y mujeres del deporte.»  La FIE ofrece sus más sinceras condolencias por su pérdida a la hermana de la Sra. Pascu, Nicoleta, a su familia y amigos, a la Federación Rumana de Esgrima y a la Confederación Europea de Esgrima, y expresa su más sentido pésame en estos momentos tan difíciles.  </p>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim
            .to(idOf("53-1"), 0.3,{display: 'block'}, 0)
            .fromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(idOf("53-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)
        }

        function pg53Toggle(id, btn) {
          var ele = idOf(id)
          var but = idOf(btn)
          TweenMax.to(cOf("53-div"), 0.01, {display: 'none'});
          TweenMax.to(cOf("53-btn"), 0.01, {opacity: 0});
          TweenMax.to(ele, 0.1, {display: 'block'});
          TweenMax.to(but, 0.1, {opacity: 1});
        }
        
        function togglePage(id, klass, text, texttwo) {
          var ele = idOf(id)
          var but = cOf(klass)
          var txt = idOf(text)
          var txt2 = cOf(texttwo)
          TweenMax.to(but, 0.01, {opacity: 0});
          TweenMax.to(txt2, 0.01, {opacity: 0});
          TweenMax.to(ele, 0.01, {opacity:1});
          TweenMax.to(txt, 0.01, {opacity:1});
        }
        
        function onPageLeave(){
          pg53Toggle('53-text-1', '53-cta-1');
          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');
          pg53Anim.stop();
          resetNumbers("53-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "RECUERDO  NECROLÓGICAS JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) y participó en Campeonatos del Mundo y de Europa, y fue nombrado Maestro del Deporte de la URSS en 1985.  La FIE lamenta el fallecimiento de Jahangir Safarov (AZE) el 12 de noviembre. Fue entrenador del equipo nacional de esgrima de Azerbaiyán y árbitro nacional. Nació el 9 de marzo de 1968. Safarov comenzó a practicar la esgrima a los 10 años. Llegó a ser medallista en numerosas competencias de la URSS  En 2001, se convirtió en el entrenador del equipo nacional de Azerbaiyán, del que salieron varios campeones nacionales y medallistas en pruebas internacionales y regionales, y fue el entrenador principal de sable femenino cadetes. La alumna de Safarov, Zarifa Huseynova, ganó la medalla de bronce en sable femenino cadetes individual en los Campeonatos del Mundo  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Pulse arriba para ver  1  2  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
        <a href="http://www.gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 599px; width: 228px; height: 38px;"></div>
        </a>
        <a href="mailto:sales@gfencing.com" target="_blank">
          <div class="contentLinkNone" style="bottom: 186px; right: 340px; width: 236px; height: 38px;"></div>
        </a>
      `,
      "mobileHtml": `
        <a href="http://www.gfencing.com" target="_blank">
          <img src="/120/es/static/_content/54-mobile-1.jpg">
        </a>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": [
      {
        title: "Escrime XXI No. 120",
        link: "Escrime XXI No. 120",
        cssClass: "cover mobile-p1",
        hideInMenu: false,
        pageLinks: [
          {
            index: 0,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 2,
            subIndex: 0
          }
        ]
      },
      {
        title: "COMITÉ EJECUTIVO DE LA FIE",
        link: "COMITÉ EJECUTIVO DE LA FIE",
        cssClass: "blue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 4,
            subIndex: 0
          }
        ]
      },
      {
        title: "PRÓLOGO",
        link: "PRÓLOGO",
        cssClass: "darkblue",
        hideInMenu: false,
        pageLinks: [
          {
            index: 5,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 6,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Tashkent",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 7,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Orleans",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 9,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 12,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Tallinn",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 13,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Bern",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 16,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 18,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | St Maur",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 19,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Paris",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 21,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 23,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Poznan",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 24,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Tbilisi",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 26,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 29,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Plovdiv",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 30,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Doha",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 32,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Budapest",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 34,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 37,
            subIndex: 0
          }
        ]
      },
      {
        title: "DEPORTE",
        link: "DEPORTE | Dubai",
        cssClass: "red",
        hideInMenu: false,
        pageLinks: [
          {
            index: 38,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 43,
            subIndex: 0
          }
        ]
      },
      {
        title: "FIE",
        link: "Noticias de la FIE",
        cssClass: "pink",
        hideInMenu: false,
        pageLinks: [
          {
            index: 44,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 45,
            subIndex: 0
          }
        ]
      },
      {
        title: "Noticias de confederación y federación",
        link: "Noticias de confederación y federación | Togo",
        cssClass: "green",
        hideInMenu: false,
        pageLinks: [
          {
            index: 46,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 49,
            subIndex: 0
          }
        ]
      },
      {
        title: "NOTICIAS DEL MUNDO",
        link: "NOTICIAS DEL MUNDO",
        cssClass: "orange",
        hideInMenu: false,
        pageLinks: [
          {
            index: 50,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 51,
            subIndex: 0
          }
        ]
      },
      {
        title: "NECROLÓGICAS",
        link: "NECROLÓGICAS",
        cssClass: "grey",
        hideInMenu: false,
        pageLinks: [
          {
            index: 52,
            subIndex: 0
          }
        ]
      },
      {
        title: "Advert",
        link: "Advert",
        cssClass: "advert",
        hideInMenu: true,
        pageLinks: [
          {
            index: 53,
            subIndex: 0
          }
        ]
      },
    ],
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js